<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_ARD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div v-if="!bool_isDeposit" class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ this.getLanguage["DLSR"]["MGBT"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeARD">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div>
                                        <CCol>
                                            <div class="custom-table-wrapper">
                                                <div class="pageBtn">
                                                    <button @click="ctrPageAR(+int_Page_AR - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page_AR"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPageAR(+int_Page_AR,0)" />
                                                    <span class="tableItemCount">/ {{int_TP_AR}}</span>
                                                    <button @click="ctrPageAR(+int_Page_AR + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%;">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['PM']['GPROV']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BI']}}
                                                            </th>

                                                            <th style="width: 20%;">
                                                                {{this.getLanguage['BETRPT']['G']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BA']}}
                                                            </th>
                                                            <th style="width: 15%;">
                                                                {{this.getLanguage['BETRPT']['BT']}}
                                                            </th>
                                                            <th style="width: 5%;">
                                                                {{this.getLanguage['MEM']['CI']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['MEM']['TO']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['WL']}}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" class="text-center" v-if="obj_trans == null || obj_trans.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_trans">
                                                        <td>{{ CountItem(index+1) }}</td>
                                                        <td>{{ renderProviderName(data.PN) }}</td>
                                                        <td>{{ data.TI }}</td>

                                                        <td>{{ renderGameName(data.PN, data.GN) }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.ISOC, false) }}</td>
                                                        <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</td>
                                                        <td>{{ data.ISOC }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.TA, 2, data.ISOC, false) }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.WLA, 2, data.ISOC, false) }}</td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                    <div v-if="bool_isDeposit" class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ this.getLanguage["DLSR"]["MD"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeARD">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div>
                                        <CCol>
                                            <div class="custom-table-wrapper">
                                                <div class="pageBtn">
                                                    <button @click="ctrPageAR(+int_Page_AR - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page_AR"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPageAR(+int_Page_AR,0)" />
                                                    <span class="tableItemCount">/ {{int_TP_AR}}</span>
                                                    <button @click="ctrPageAR(+int_Page_AR + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th style="width: 10%;" class="tableCtnRight">{{this.getLanguage["MTA"]["TA"]}}</th>
                                                            <th style="width: 10%;">{{this.getLanguage["MTA"]["PM"]}}</th>
                                                            <th style="width: 10%;">{{this.getLanguage["MTA"]["TID"]}}</th>
                                                            <th style="width: 15%;">{{this.getLanguage['CR']['CT']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" class="text-center" v-if="obj_trans == null || obj_trans.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_trans">
                                                        <td>{{ CountItem(index+1) }}</td>
                                                        <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.TRA, 2, data.CS) }}</td>
                                                        <td>{{ renderPaymentMethod(data.PM) }}</td>
                                                        <td>
                                                            <div v-if="data.TID != ''">
                                                                <span v-if="data.TID != ''" class="grid-line">{{ data.TID }}</span>
                                                            </div>
                                                            <div v-else>
                                                                <span>-</span>
                                                            </div>
                                                        </td>
                                                        <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--  modal edit member, freeze, block, gamesetting -->
        <MemberCombineModal :editMemberInfo.sync="editMemberInfo" :editMemberBlock.sync="editMemberBlock" :editMemberFreeze.sync="editMemberFreeze" :editMemberGame.sync="editMemberGame"/>

        <div v-if="bool_isMegaGamingTransfer">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 500px;">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{CurrentGPI==100?"Mega888 Transfer":"MegaV3 Transfer"}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeMegaGamingTransfer()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="modal-main-content">
                                    <CRow v-if="CurrentGPI==100">
                                        <CCol>
                                            <p style="margin-top:10px;">
                                                Member Mega888 Balance : <span>{{ formatNumber(obj_member.MGW, 2, obj_member.TOTLWTCS) }}</span>
                                            </p>
                                        </CCol>
                                        <!--<span>Member Mega888 Balance : </span><span>{{ formatNumber(obj_member.MGW, 2, obj_member.TOTLWTCS) }}</span>-->
                                    </CRow>
                                    <CRow v-if="CurrentGPI==106">
                                        <CCol>
                                            <p style="margin-top:10px;">
                                                Member MegaV3 Balance : <span>{{ formatNumber(obj_member.MV3GW, 2, obj_member.TOTLWTCS) }}</span>
                                            </p>
                                        </CCol>
                                        <!--<span>Member MegaV3 Balance : </span><span>{{ formatNumber(obj_member.MV3GW, 2, obj_member.TOTLWTCS) }}</span>-->
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Deposit :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="megaGamingDepositAmount"
                                                    :value="ThousandSeparator(megaGamingDepositAmount, 2)"
                                                    @change="v => megaGamingDepositAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='megaGamingTransfer(0, megaGamingDepositAmount,CurrentGPI)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Withdrawal :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="megaGamingWithdrawAmount"
                                                    :value="ThousandSeparator(megaGamingWithdrawAmount, 2)"
                                                    @change="v => megaGamingWithdrawAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='megaGamingTransfer(1, megaGamingWithdrawAmount,CurrentGPI)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isPussy888Transfer">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 500px;">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">Pussy888 Transfer</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closePussy888Transfer()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol>
                                            <p style="margin-top:10px;">
                                                Member Pussy888 Balance : <span>{{ formatNumber(obj_member.PW, 2, obj_member.TOTLWTCS) }}</span>
                                            </p>
                                        </CCol>
                                        <!--<span>Member Pussy888 Balance : </span><span>{{ formatNumber(obj_member.PW, 2, obj_member.TOTLWTCS) }}</span>-->
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Deposit :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="Pussy888DepositAmount"
                                                    :value="ThousandSeparator(Pussy888DepositAmount, 2)"
                                                    @change="v => Pussy888DepositAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='Pussy888Transfer(0, Pussy888DepositAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Withdrawal :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="Pussy888WithdrawAmount"
                                                    :value="ThousandSeparator(Pussy888WithdrawAmount, 2)"
                                                    @change="v => Pussy888WithdrawAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='Pussy888Transfer(1, Pussy888WithdrawAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isKiss918Transfer">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 500px;">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">918Kiss Transfer</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeKiss918Transfer()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol>
                                            <p style="margin-top:10px;">
                                                Member 918Kiss Balance : <span>{{ formatNumber(obj_member.K918W, 2, obj_member.TOTLWTCS) }}</span>
                                            </p>
                                        </CCol>
                                        <!--<span>Member 918Kiss Balance : </span><span>{{ formatNumber(obj_member.K918W, 2, obj_member.TOTLWTCS) }}</span>-->
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Deposit :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="Kiss918DepositAmount"
                                                    :value="ThousandSeparator(Kiss918DepositAmount, 2)"
                                                    @change="v => Kiss918DepositAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='Kiss918Transfer(0, Kiss918DepositAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Withdrawal :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="Kiss918WithdrawAmount"
                                                    :value="ThousandSeparator(Kiss918WithdrawAmount, 2)"
                                                    @change="v => Kiss918WithdrawAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='Kiss918Transfer(1, Kiss918WithdrawAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isIG_GFCTransfer">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 500px;">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">IG Lottery Transfer</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeIG_GFCTransfer()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol>
                                            <p style="margin-top:10px;">
                                                Member IG Lottery Balance : <span>{{ formatNumber(obj_member.IGGFCW, 2, obj_member.TOTLWTCS) }}</span>
                                            </p>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Deposit :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="IG_GFCDepositAmount"
                                                    :value="ThousandSeparator(IG_GFCDepositAmount, 2)"
                                                    @change="v => IG_GFCDepositAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='IG_GFCDeposit(IG_GFCDepositAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Withdrawal :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="IG_GFCWithdrawAmount"
                                                    :value="ThousandSeparator(IG_GFCWithdrawAmount, 2)"
                                                    @change="v => IG_GFCWithdrawAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='IG_GFCWithdraw(IG_GFCWithdrawAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--<div v-if="bool_isIG_LOTTERYTransfer">
        <transition name="modal-fade">
            <div class="modal-backdrop" margin="auto">
                <div class="popupWindow" style="max-width: 500px;">
                    <CCard style="height:100%; overflow: hidden auto;">
                        <CCardBody class="modal-body" id="modalDescription">
                            <CRow>
                                <CCol col="10">
                                    <h4 id="traffic" class="card-title mb-0">IG Instant Lottery Transfer</h4>
                                </CCol>
                                <CCol col="2">
                                    <CButton id="btn-close1" class="float-right" @click="closeIG_LOTTERYTransfer()">
                                        <CIcon name=cilX></CIcon>
                                    </CButton>
                                </CCol>
                            </CRow>
                            <div class="modal-main-content">
                                <CRow>
                                    <CCol>
                                        <p style="margin-top:10px;">
                                            Member IG Instant Lottery Balance : <span>{{ formatNumber(obj_member.IGLOTTERYW, 2, obj_member.TOTLWTCS) }}</span>
                                        </p>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="9">
                                        <label class='col-form-label-sm'>Deposit :</label>
                                        <CInput type="number"
                                                size="sm"
                                                vertical
                                                v-model="IG_LOTTERYDepositAmount"
                                                :value="ThousandSeparator(IG_LOTTERYDepositAmount, 2)"
                                                @change="v => IG_LOTTERYDepositAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                    </CCol>
                                    <CCol col="3" class="d-flex align-items-end">
                                        <button type="button" class="btn btn-outline-info btn-sm" @click='IG_LOTTERYDeposit(IG_LOTTERYDepositAmount)'>Submit</button>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="9">
                                        <label class='col-form-label-sm'>Withdrawal :</label>
                                        <CInput type="number"
                                                size="sm"
                                                vertical
                                                v-model="IG_LOTTERYWithdrawAmount"
                                                :value="ThousandSeparator(IG_LOTTERYWithdrawAmount, 2)"
                                                @change="v => IG_LOTTERYWithdrawAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                    </CCol>
                                    <CCol col="3" class="d-flex align-items-end">
                                        <button type="button" class="btn btn-outline-info btn-sm" @click='IG_LOTTERYWithdraw(IG_LOTTERYWithdrawAmount)'>Submit</button>
                                    </CCol>
                                </CRow>
                            </div>
                        </CCardBody>
                    </CCard>
                </div>
            </div>
        </transition>
    </div>-->
        <!--<div v-if="bool_isIG_LOTTOTransfer">
        <transition name="modal-fade">
            <div class="modal-backdrop" margin="auto">
                <div class="popupWindow" style="max-width: 500px;">
                    <CCard style="height:100%; overflow: hidden auto;">
                        <CCardBody class="modal-body" id="modalDescription">
                            <CRow>
                                <CCol col="10">
                                    <h4 id="traffic" class="card-title mb-0">IG Hong Kong Mark Six Transfer</h4>
                                </CCol>
                                <CCol col="2">
                                    <CButton id="btn-close1" class="float-right" @click="closeIG_LOTTOTransfer()">
                                        <CIcon name=cilX></CIcon>
                                    </CButton>
                                </CCol>
                            </CRow>
                            <div class="modal-main-content">
                                <CRow>
                                    <CCol>
                                        <p style="margin-top:10px;">
                                            Member IG Hong Kong Mark Six Balance : <span>{{ formatNumber(obj_member.IGLOTTOW, 2, obj_member.TOTLWTCS) }}</span>
                                        </p>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="9">
                                        <label class='col-form-label-sm'>Deposit :</label>
                                        <CInput type="number"
                                                size="sm"
                                                vertical
                                                v-model="IG_LOTTODepositAmount"
                                                :value="ThousandSeparator(IG_LOTTODepositAmount, 2)"
                                                @change="v => IG_LOTTODepositAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                    </CCol>
                                    <CCol col="3" class="d-flex align-items-end">
                                        <button type="button" class="btn btn-outline-info btn-sm" @click='IG_LOTTODeposit(IG_LOTTODepositAmount)'>Submit</button>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="9">
                                        <label class='col-form-label-sm'>Withdrawal :</label>
                                        <CInput type="number"
                                                size="sm"
                                                vertical
                                                v-model="IG_LOTTOWithdrawAmount"
                                                :value="ThousandSeparator(IG_LOTTOWithdrawAmount, 2)"
                                                @change="v => IG_LOTTOWithdrawAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                    </CCol>
                                    <CCol col="3" class="d-flex align-items-end">
                                        <button type="button" class="btn btn-outline-info btn-sm" @click='IG_LOTTOWithdraw(IG_LOTTOWithdrawAmount)'>Submit</button>
                                    </CCol>
                                </CRow>
                            </div>
                        </CCardBody>
                    </CCard>
                </div>
            </div>
        </transition>
    </div>-->
        <div v-if="bool_isWICKET9Transfer">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 500px;">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">9WICKET Transfer</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeWICKET9Transfer()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol>
                                            <p style="margin-top:10px;">
                                                Member 9WICKET Balance : <span>{{ formatNumber(obj_member.WICKET9W, 2, obj_member.TOTLWTCS) }}</span>
                                            </p>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Deposit :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="WICKET9DepositAmount"
                                                    :value="ThousandSeparator(WICKET9DepositAmount, 2)"
                                                    @change="v => WICKET9DepositAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='WICKET9Transfer(0, WICKET9DepositAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="9">
                                            <label class='col-form-label-sm'>Withdrawal :</label>
                                            <CInput type="number"
                                                    size="sm"
                                                    vertical
                                                    v-model="WICKET9WithdrawAmount"
                                                    :value="ThousandSeparator(WICKET9WithdrawAmount, 2)"
                                                    @change="v => WICKET9WithdrawAmount = RemoveThousandSeparator(v, 2)"></CInput>
                                        </CCol>
                                        <CCol col="3" class="d-flex align-items-end">
                                            <button type="button" class="btn btn-outline-info btn-sm" @click='WICKET9Transfer(1, WICKET9WithdrawAmount)'>Submit</button>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_FSD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ this.getLanguage["DLSR"]["MGBT"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeFSD">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div>
                                        <CCol>
                                            <div class="custom-table-wrapper">
                                                <div class="pageBtn table-header">
                                                    <button @click="ctrPageGBT(+int_Page_GBT - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page_GBT"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPageGBT(+int_Page_GBT,0)" />
                                                    <span class="tableItemCount">/ {{int_TP_GBT}}</span>
                                                    <button @click="ctrPageGBT(+int_Page_GBT + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                                <table class="custom-table afb-blue custom-table-inPopUp">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="100%">{{this.getLanguage['MTA']['FSS']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" class="text-center" v-if="gbtData == null || gbtData.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-else class='kema-eft'>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{{this.getLanguage['MTA']['TSW']}}</td>
                                                        <td :style="renderActivityStyle(1)" :class="gbtData.FSWA >= 0? 'positive-number' : ''" class="tableCtnRight">{{ formatNumber(gbtData.FSWA, 2,gbtData.CS) }}</td>
                                                    </tr>
                                                    </tbody>
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%;">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['PM']['GPROV']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BI']}}
                                                            </th>

                                                            <th style="width: 20%;">
                                                                {{this.getLanguage['BETRPT']['G']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BA']}}
                                                            </th>
                                                            <th style="width: 15%;">
                                                                {{this.getLanguage['BETRPT']['BT']}}
                                                            </th>
                                                            <th style="width: 5%;">
                                                                {{this.getLanguage['MEM']['CI']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['MEM']['TO']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['WL']}}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" class="text-center" v-if="obj_trans == null || obj_trans.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_trans">
                                                        <td>{{ CountItemGbt(index+1) }}</td>
                                                        <td>{{ renderProviderName(data.PN) }}</td>
                                                        <td>{{ data.TI }}</td>

                                                        <td>{{ renderGameName(data.PN, data.GN) }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.ISOC, false) }}</td>
                                                        <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</td>
                                                        <td>{{ data.ISOC }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.TA, 2, data.ISOC, false) }}</td>
                                                        <td :class="data.WLA > 0? 'positive-number' : ''" class="tableCtnRight">{{formatNumber(data.WLA, 2,"")}}</td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid overflow-hidden">
            <div class="row">
                <div class="col-12 p-2">
                    <div class="pageHeader mx-2">


                        <div class="mb-2 mr-2" id="actionBtnCol">
                            <div class="memberlist-action-btn turnOnRefresh" @click='refreshMemberProfile(obj_member.AGI,obj_member.I)'>
                                <div class="action-icon">
                                    <i class="cil-reload"></i>
                                </div>
                                <span>{{getLanguage["BTN"]["RF"]}}</span>
                            </div>
                            <div class="memberlist-action-btn turnOnSetting" @click='editMember(obj_member)' v-if="checkModuleAccess('ML', 'M', constAccessType.edit)">
                                <div class="action-icon">
                                    <i class="cil-color-border"></i>
                                </div>
                                <span>{{getLanguage["BTN"]["ED"]}}</span>
                            </div>
                            <div>
                                <div class="memberlist-action-btn turnOnSetting" @click='editMemberGameSetting(obj_member)' v-if="checkModuleAccess('ML', 'M', constAccessType.edit) && (getUserInfo.AT != 4)">
                                    <div class="action-icon">
                                        <i class="cil-settings"></i>
                                    </div>
                                    <span>{{getLanguage["BTN"]["GS"]}}</span>
                                </div>
                                <div class="memberlist-action-btn turnOnSetting" @click='editMemberGameSetting(obj_member)' v-else-if="checkModuleAccess('ML', 'M', constAccessType.edit) && (getUserInfo.AT == 4 &&  getUserInfo.IOL)">
                                    <div class="action-icon">
                                        <i class="cil-settings"></i>
                                    </div>
                                    <span>{{getLanguage["BTN"]["GS"]}}</span>
                                </div>
                            </div>
                            <div class="memberlist-action-btn turnOffBlock" @click="unBlacklistMember(obj_member)" v-if="obj_member.RS == 1 && checkModuleAccess3(constAccessType.add) && checkModuleAccess('ML', 'M', constAccessType.delete)">
                                <div class="action-icon">
                                    <i class="cil-action-undo"></i>
                                </div>
                                <span>{{getLanguage["BTN"]["UDO"]}}</span>
                            </div>
                            <div class="memberlist-action-btn turnOnBlock" @click="blacklistMember(obj_member)" v-if="obj_member.RS != 1 && checkModuleAccess3(constAccessType.add) && checkModuleAccess('ML', 'M', constAccessType.delete)">
                                <div class="action-icon">
                                    <i class="cil-ban"></i>
                                </div>
                                <span>{{getLanguage["BTN"]["BLK"]}}</span>
                            </div>
                            <div class="memberlist-action-btn turnOffFreeze" @click="unFreezeMember(obj_member)" v-if="obj_member.RS == 3 && checkModuleAccess3(constAccessType.add) && checkModuleAccess('ML', 'M', constAccessType.delete)">
                                <div class="action-icon">
                                    <i class="cil-action-undo"></i>
                                </div>
                                <span>{{getLanguage["BTN"]["UFR"]}}</span>
                            </div>
                            <div class="memberlist-action-btn turnOnFreeze" @click="freezeMember(obj_member)" v-if="obj_member.RS != 3 && checkModuleAccess3(constAccessType.add) && checkModuleAccess('ML', 'M', constAccessType.delete)">
                                <div class="action-icon">
                                    <i class="cil-snowflake"></i>
                                </div>
                                <span>{{getLanguage["BTN"]["FK"]}}</span>
                            </div>
                            <div class="memberlist-action-btn" :class="dlsIsDisabled ? 'turnOffPromo' : 'turnOnPromo'" :style="disabledPointer()" @click="!checkModuleAccess('ML', 'M', constAccessType.edit) ? null : disableMemberPromotion(obj_member, 1, dlsIsDisabled)">
                                <div class="action-icon">
                                    <svg v-if="dlsIsDisabled" style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#e53636" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                    <svg v-else style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#2eb85c" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                </div>
                                <span>{{getLanguage["MEM"]["REWARD"]}}</span>
                            </div>
                            <div class="memberlist-action-btn" :class="autoRIsDisabled ? 'turnOffPromo' : 'turnOnPromo'" :style="disabledPointer()" @click="!checkModuleAccess('ML', 'M', constAccessType.edit) ? null : disableMemberPromotion(obj_member, 2, autoRIsDisabled)">
                                <div class="action-icon">
                                    <svg v-if="autoRIsDisabled" style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#e53636" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                    <svg v-else style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#2eb85c" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                </div>
                                <span>{{getLanguage["BTN"]["ARB"]}}</span>
                            </div>
                            <div class="memberlist-action-btn" :class="refIsDisabled ? 'turnOffPromo' : 'turnOnPromo'" :style="disabledPointer()" @click="!checkModuleAccess('ML', 'M', constAccessType.edit) ? null : disableMemberPromotion(obj_member, 3, refIsDisabled)">
                                <div class="action-icon">
                                    <svg v-if="refIsDisabled" style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#e53636" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                    <svg v-else style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#2eb85c" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                </div>
                                <span>{{getLanguage["BTN"]["RFR"]}}</span>
                            </div>
                            <div class="memberlist-action-btn" :class="prizeDIsDisabled ? 'turnOffPromo' : 'turnOnPromo'" :style="disabledPointer()" @click="!checkModuleAccess('ML', 'M', constAccessType.edit) ? null : disableMemberPromotion(obj_member, 4, prizeDIsDisabled)">
                                <div class="action-icon">
                                    <svg v-if="prizeDIsDisabled" style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#e53636" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                    <svg v-else style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#2eb85c" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                </div>
                                <span>{{getLanguage["BTN"]["PD"]}}</span>
                            </div>
                            <!--Turn Tournament On/Off Button-->
                            <!--<div class="memberlist-action-btn" :class="tournamentIsDisabled ? 'turnOffPromo' : 'turnOnPromo'" @click='disableMemberPromotion(obj_member, 5, tournamentIsDisabled)'>
        <div class="action-icon">
            <svg v-if="tournamentIsDisabled" style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#e53636" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            <svg v-else style="margin-top:-2px" width="18px" height="18px" viewBox="-7.2 -7.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-7.2" y="-7.2" width="38.40" height="38.40" rx="19.2" fill="#2eb85c" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M12 3V12M18.3611 5.64001C19.6195 6.8988 20.4764 8.50246 20.8234 10.2482C21.1704 11.994 20.992 13.8034 20.3107 15.4478C19.6295 17.0921 18.4759 18.4976 16.9959 19.4864C15.5159 20.4752 13.776 21.0029 11.9961 21.0029C10.2162 21.0029 8.47625 20.4752 6.99627 19.4864C5.51629 18.4976 4.36274 17.0921 3.68146 15.4478C3.00019 13.8034 2.82179 11.994 3.16882 10.2482C3.51584 8.50246 4.37272 6.8988 5.6311 5.64001" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
        </div>
        <span>{{getLanguage["BTN"]["TNMT"]}}</span>
    </div>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 col-lg-5 pr-lg-0 mb-2" style="padding-top: 0 !important">
                    <div class="card theme-box-container theme-bg-white border-radius-10 w-100 h-100">
                        <div class="card-body">
                            <div class="row">
                                <!-- profile card with loyalty-->
                                <div class="col-md-12" style=" margin-top: -0.75rem; margin-bottom: .5rem; padding: 0rem 0.15rem !important;" v-if="obj_member.MRCURL && obj_member.MRIURL && obj_member.BN > 0">
                                    <div class="card theme-box-container border-radius-10 w-100 h-100" :class="'theme-loyalbgvip D'+(obj_member.BN)+'C'+(obj_member.CRK -1)">
                                        <div class="card-body p-2">
                                            <div class="d-flex">
                                                <!--<div class="col-md-12">-->
                                                <div style="height:84px;width:170px">
                                                    <div :class="'loyalD'+(obj_member.BN)+' card'+(obj_member.CRK -1)" :style="'background:url('+obj_member.MRCURL+ ')'+ (obj_member.BN == 4 || obj_member.BN == 5 ||  obj_member.BN == 6? ', #000' : '')+';transform: scale(0.53); transform-origin: top left;box-shadow: 1px 0px 4px #f5eded;' ">
                                                        <img :src="(obj_member.MRIURL)" class="img-fluid" :class="'badgeD'+(obj_member.BN)+'_'+(obj_member.CRK -1)" />
                                                        <p class="mb-0" :class="'cardnnoD'+(obj_member.BN)">{{obj_member.CN}}</p>
                                                        <p class="mb-0" :class="'memberidD'+(obj_member.BN)">{{obj_member.U}}</p>
                                                        <div :class="'rankingNameD'+(obj_member.BN)">
                                                            <p class="mb-0">{{ obj_member.MRIN }}</p>
                                                            <div class="loyalprogram-progress-container" style=" height: 5px; width: 130px;">
                                                                <div class="loyalprogram-progress" :style="'height:5px;width: '+ ((obj_member.CRK -1) == 4 ? '100%;' : + ((obj_member.TPNT/(obj_member.TST+0.01)) * 100)+'%')"></div>
                                                            </div>
                                                        </div>
                                                        <p class="mb-0" :class="'cardnyearD'+(obj_member.BN)">{{ DateTime | moment("YYYY") }}</p>
                                                    </div>
                                                </div>
                                                <div class="mt-2 mt-md-0">
                                                    <span class="d-block">{{ this.getLanguage["MR"]["CP"] }} : <strong style="color: #ffcc00; text-shadow: 1px 1px #202020;">{{ obj_member.TPNT.toFixed(2) }}</strong></span>
                                                    <span class="d-block" v-if="formatDateTime(obj_member.MRED, 'YYYY-MM-DD', 'DD MMM YYYY') != '31 Dec 9999'">{{this.getLanguage["MR"]["RE"] }}  <strong style="color: #ffcc00; text-shadow: 1px 1px #202020;">{{ formatDateTime(obj_member.MRED, "YYYY-MM-DD", "DD MMM YYYY") }}</strong></span>

                                                    <div class="mt-2" v-if="obj_member.TST != 999999999">
                                                        <div class="loyalprogram-progress-container position-relative" style=" height: 10px; ">
                                                            <div class="loyalprogram-progress" :style="'width:'+ (((obj_member.TPNT/(obj_member.TST+0.01)) * 100)).toFixed(2)+'%;height: 10px; font-size: 8px; line-height: 10px;' "> </div>
                                                            <div style=" position: absolute; top: -1px; color: #000; font-weight: bold; font-size: 9px;left:3px;">{{ ((obj_member.TPNT/(obj_member.TST+0.01)) * 100).toFixed(2) }}%</div>
                                                        </div>
                                                        <span class="d-block">{{String.format(this.getLanguage["MR"]["PI"], ((obj_member.TST+0.01) - obj_member.TPNT).toFixed(2)) }}</span>
                                                    </div>

                                                    <span class="d-block mt-2" v-if="(obj_member.TSF - obj_member.TPNT) > 0">{{String.format(this.getLanguage["MR"]["PR"], (obj_member.TSF - obj_member.TPNT).toFixed(2)) }}</span>
                                                </div>
                                                <!--</div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- profile card -->
                                <div class="col-md-12" :class="(!obj_member.MRCURL && !obj_member.MRIURL) ? 'px-1' : ''" :style="(!obj_member.MRCURL && !obj_member.MRIURL) ? 'margin-top: -0.75rem; margin-bottom: 1rem;' : ''">
                                    <div :class="(!obj_member.MRCURL && !obj_member.MRIURL) ? 'theme-bg-darkblack card theme-box-container border-radius-10 w-100 h-100' : ''">
                                        <div :class="(!obj_member.MRCURL && !obj_member.MRIURL) ? 'card-body p-2' : ''">
                                            <div class="row">
                                                <div class="col-md-5" v-if="!obj_member.MRCURL && !obj_member.MRIURL">
                                                    <img src="../../../../assets/icons/profile.svg" width="80" style="opacity:0.8" />
                                                </div>
                                                <div :class="(!obj_member.MRCURL && !obj_member.MRIURL) ? 'col-md-7' : 'col-md-12'">
                                                    <h5 class="d-flex position-relative mb-1">
                                                        <strong class="row" style="margin-left:0px;">
                                                            <div class="custom_tooltip">
                                                                <span :style="getbgtooltip(obj_member)" @click.stop>{{obj_member.U}}</span>
                                                                <span v-if="convertToBool(obj_member.MT)" class="tooltiptext tooltip-right" :style="getbgtooltip(obj_member)">{{obj_member.MT}}</span>
                                                            </div>
                                                            <div class="indicator_icon">
                                                                <div class="custom_tooltip" v-if="obj_member.TW == 0">
                                                                    <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                                                </div>
                                                                <div class="custom_tooltip" v-if="obj_member.HTWT">
                                                                    <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                                                </div>
                                                                <div class="custom_tooltip" v-if="obj_member.RP">
                                                                    <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                                                </div>
                                                                <div class="custom_tooltip" v-if="(obj_member.OS == 1)">
                                                                    <svg width="15px" height="15px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                        <g id="System / Wifi_High" style="fill: transparent">
                                                                            <path id="Vector" d="M8.34277 14.5899C8.80861 14.0903 9.37187 13.6915 9.9978 13.418C10.6237 13.1446 11.2995 13.0025 11.9826 13.0001C12.6656 12.9977 13.3419 13.1353 13.9697 13.4044C14.5975 13.6735 15.1637 14.0683 15.633 14.5646M6.14941 11.5439C6.89476 10.7446 7.79597 10.1066 8.79745 9.66902C9.79893 9.23148 10.8793 9.00389 11.9721 9.00007C13.065 8.99626 14.1466 9.21651 15.1511 9.64704C16.1556 10.0776 17.0617 10.7094 17.8127 11.5035M3.22363 8.81635C4.34165 7.61742 5.69347 6.66028 7.19569 6.00398C8.69791 5.34768 10.3179 5.0058 11.9572 5.00007C13.5966 4.99435 15.2208 5.32472 16.7276 5.97052C18.2344 6.61632 19.5931 7.56458 20.7195 8.75568M12 19.0001C11.4477 19.0001 11 18.5524 11 18.0001C11 17.4478 11.4477 17.0001 12 17.0001C12.5523 17.0001 13 17.4478 13 18.0001C13 18.5524 12.5523 19.0001 12 19.0001Z" stroke="#00b64d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                    </svg>
                                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MEM"]["MIO"]}}</span>
                                                                </div>
                                                                <div class="custom_tooltip" v-if="(obj_member.OS != 1)">
                                                                    <svg width="15px" height="15px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                        <g id="System / Wifi_Off">
                                                                            <path id="Vector" d="M17.8506 11.5442C17.0475 10.6829 16.0641 10.0096 14.9707 9.57227M20.7759 8.81625C19.5712 7.52437 18.0961 6.51439 16.4561 5.8584C14.816 5.20241 13.0514 4.91635 11.2881 5.02111M8.34277 14.5905C8.95571 13.9332 9.73448 13.4532 10.5971 13.2012C11.4598 12.9491 12.3745 12.9335 13.2449 13.1574M6.14941 11.5438C7.09778 10.5268 8.29486 9.77461 9.62259 9.36133M3.22363 8.81604C4.1215 7.85319 5.17169 7.04466 6.33211 6.42285M4.41406 4L18.5562 18.1421M12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19Z" stroke="#ff0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                    </svg>
                                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MEM"]["MIOFF"]}}</span>
                                                                </div>
                                                                <div class="label-active">
                                                                    <div class="custom_tooltip">
                                                                        <small :class="(obj_member.RS > 1)? ((obj_member.RS==3)?'text-info':'text-green-3'): 'text-red1'">
                                                                            {{utilGetErrorLanguage(obj_member.RSD)}}
                                                                        </small>
                                                                        <span class="tooltiptext" style="background-color: black; color: white; bottom: 65%;">{{getLanguage["MEM"]["MI"]}} {{utilGetErrorLanguage(obj_member.RSD)}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </strong>
                                                    </h5>
                                                    <span>{{ getLanguage['GL']['AGT'] }} : <strong>{{ obj_member.AGN }}</strong><span v-if="obj_member.SAGN != null && obj_member.SAGN != ''" class="ml-2">| {{ obj_member.SAGN }}</span></span><br />
                                                    <span>{{ getLanguage["MEM"]["CI"] }} : <strong><span v-if="obj_member.ICT">{{ obj_member.CS }}</span><span v-else>{{ obj_member.IC }}</span></strong></span><br />
                                                    <span v-if="obj_member.RU != ''" class="text-info">{{ this.getLanguage["MEM"]["RI"] }} : <strong>{{ obj_member.RU }}</strong></span>
                                                    <span v-else-if="obj_member.RSN != ''" class="text-info">{{ this.getLanguage["MEM"]["RSN"] }} : <strong>{{obj_member.RSN}}</strong></span>
                                                    <span v-else>{{ this.getLanguage["MEM"]["RSN"] }} : <strong>{{getLanguage["MEM"]["DIR"]}}</strong></span><br />
                                                    <span>{{ this.getLanguage["MEM"]["RC"] }} : <strong>{{ obj_member.RC }}</strong></span><br />
                                                    <span class="text-warning" v-if="obj_member.R">{{ this.getLanguage["MEM"]["BR"] }} : <strong>{{obj_member.R}}</strong></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="subHeaderHR my-2" :class="(!obj_member.MRCURL && !obj_member.MRIURL) ? 'd-none' : 'd-block'" style="border-top: solid 2px rgb(229 229 229 / 50%);"></div>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="row">
                                        <!-- 8 icon -->
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 0}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                            <g>
                                                            <g>
                                                            <circle cx="375.6" cy="350.5" r="15.1" />
                                                            <circle cx="215.8" cy="350.5" r="15.1" />
                                                            <circle cx="136.4" cy="350.5" r="15.1" />
                                                            <circle cx="295.2" cy="350.5" r="15.1" />
                                </g>
                                                            <path d="M101.6,512.1c-38-2-68.3-33.6-68.3-72.1V268.7c0-39.8,32.4-72.2,72.2-72.2H142v-85.2C142,49.9,193.1-0.1,256-0.1c62.8,0,113.9,50,113.9,111.3v85.1h36.6c39.8,0,72.2,32.4,72.2,72.2v77.3c0,5.2-4.2,9.4-9.4,9.4s-9.4-4.2-9.4-9.4v-77.3c0-29.4-23.9-53.3-53.3-53.3h-301c-29.4,0-53.3,23.9-53.3,53.3v171.4c0,29.4,23.9,53.3,53.3,53.3h301c29.4,0,53.3-23.9,53.3-53.3c0-5.2,4.2-9.4,9.4-9.4s9.4,4.2,9.4,9.4c0,39.8-32.4,72.2-72.2,72.2H101.6z M256,18.8c-52.4,0-95,41.4-95,92.4v85.2h190v-85.2C351,60.3,308.4,18.8,256,18.8z" />
                                </g>
                                </svg>
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP0"]}}</span>
                                                        <span v-if="obj_member.TP > 0" class="badge badge-pill badge-danger">{{ obj_member.TP }}</span> <i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>

                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 4}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.9 511.9" width="16" height="16" style="enable-background:new 0 0 511.9 511.9;" xml:space="preserve">
                                                            <g>
                                                            <path d="M152.4,511.8c-25.6,0-46.4-20.8-46.4-46.4V46.5c0-25.6,20.8-46.4,46.4-46.4h207.1c25.6,0,46.4,20.8,46.4,46.4v418.9c0,25.6-20.8,46.4-46.4,46.4H152.4z M124.8,465.4c0,15.1,12.3,27.5,27.5,27.5h207.1c15.1,0,27.5-12.3,27.5-27.5v-46.5H124.8V465.4zM124.8,400H387V90.6H124.8V400z M152.4,19c-15.1,0-27.5,12.3-27.5,27.5v25.1h262.2V46.5c0-15.1-12.3-27.5-27.5-27.5H152.4z" />
                                                            <path d="M255.9,474.9c-11.1,0-20.1-9-20.1-20.1s9-20.1,20.1-20.1c11.1,0,20.1,9,20.1,20.1S267,474.9,255.9,474.9z" />
                                </g>
                                </svg>
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP4"]}}</span>
                                                        <span v-if="obj_member.TPN > 0" class="badge badge-pill badge-danger">{{ obj_member.TPN }}</span> <i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>

                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 1}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                            <g>
                                                            <g>
                                                            <path d="M235.3,178.1c0,2.6-0.9,4.8-2.8,6.7c-1.9,1.8-4.1,2.8-6.8,2.8c-2.7,0-4.9-0.9-6.8-2.8s-2.8-4.1-2.8-6.8v-67.8c0-2.5,1-4.8,2.9-6.8c1.9-2,4.2-3,6.8-3s4.8,1,6.7,2.9c1.8,1.9,2.8,4.2,2.8,6.9V178.1z" />
                                                            <path d="M270.1,157.8v19.3c0,2.6-0.9,4.8-2.8,6.7c-1.9,1.9-4.1,2.8-6.7,2.8s-4.8-0.9-6.7-2.8c-1.9-1.9-2.8-4.2-2.8-7v-66.4c0-2.8,1-5.2,2.9-7.1c1.9-1.9,4.3-2.9,7-2.9h22.4c8.9,0,16.1,2.7,21.7,8c5.6,5.4,8.4,12.3,8.4,20.9c0,8.5-2.6,15.4-7.9,20.6c-5.3,5.2-12.3,7.9-21,7.9H270.1z M270.1,117.6v23.5h12.2c3.1,0,5.7-1.1,8-3.4c2.3-2.3,3.4-5,3.4-8.2c0-3.3-1.1-6.1-3.2-8.4c-2.2-2.3-4.9-3.5-8.1-3.5H270.1z" />
                                                            <path d="M451.3,359.1c-3.3-4.5-9.5-5.4-14-2.1c-4.5,3.3-5.4,9.5-2.1,14c14.5,19.7,25.4,41.4,32.7,64.2c-21.4-22-53.2-40.3-92.1-52.7c-1-3.2-2.1-6.4-3.2-9.6c-12.1-34.1-28.8-62.1-48.6-81.7c0.1-0.1,0.2-0.2,0.3-0.4c21.5,6.9,41.7,17.1,60.3,30.2c1.8,1.3,3.8,1.8,5.8,1.8c3.1,0,6.2-1.5,8.2-4.2c3.2-4.5,2.1-10.8-2.4-14c-18.2-12.9-37.8-23.2-58.7-30.6c32.9-42.9,60.3-89.5,60.3-132.4C397.8,63.6,334.2,0,256,0S114.2,63.6,114.2,141.8c0,30.5,13.9,65.7,42.6,107.7c5.7,8.3,11.7,16.5,17.9,24.6c-43.8,15.7-82.9,44.2-111.3,81.4C31,397.9,13.9,448.7,13.9,502.2c0,5.5,4.5,10,10,10h464.2c5.5,0,10-4.5,10-10C498.1,450.3,481.9,400.8,451.3,359.1z M352.2,375.9c-15.5-3.8-32-6.6-49.1-8.5c-1.9-12.2-8.6-23.2-18.4-30.6c8.5-9.6,17.4-19.7,26.3-30.1C327.7,323.6,341.7,347.5,352.2,375.9z M134.3,141.8c0-67.1,54.6-121.7,121.7-121.7s121.7,54.6,121.7,121.7c0,60.5-69.2,138.1-114.9,189.5c-2.3,2.6-4.6,5.2-6.8,7.7c-2.1-2.4-4.3-4.9-6.6-7.4C203.6,280,134.3,202.2,134.3,141.8z M227.3,336.8c-9.7,7.4-16.4,18.3-18.3,30.6c-17.2,1.9-33.6,4.8-49.2,8.5c10.5-28.4,24.5-52.3,41.2-69.3C210,317.2,218.9,327.3,227.3,336.8z M118.7,492.2H34.8c5.8-35,41.9-66.5,94.9-86.2C123.1,433.1,119.3,462.3,118.7,492.2z M44.5,434.8c21.6-67.1,74.4-121.8,143.4-144c0.1,0.1,0.2,0.2,0.3,0.3c-19.8,19.6-36.5,47.6-48.6,81.7c-1.1,3.2-2.2,6.4-3.2,9.6C97.6,394.8,65.9,413,44.5,434.8z M246,492.2H138.7c0.8-33.2,5.6-65.1,13.7-93.6c17.9-5.1,37.2-8.9,57.6-11.2c4.7,17.2,18.6,30.3,36,34L246,492.2L246,492.2z M258.8,402.3c-1.5,0.1-2.9,0.2-4.4,0.1c-14.5-0.8-26.1-12.9-26.1-27.6c0-9.3,4.7-17.9,12.3-23c2.7,3.1,5.3,6,7.9,8.9c1.9,2.2,4.6,3.4,7.5,3.4s5.6-1.2,7.5-3.4c2.5-2.9,5.1-5.8,7.9-8.9c7.5,5.1,12.3,13.7,12.3,23c0,3.7-0.8,7.4-2.2,10.8C277.6,394.6,269.1,401.2,258.8,402.3C258.9,402.3,258.8,402.3,258.8,402.3C258.4,402.3,258.8,402.3,258.8,402.3C257.4,402.4,258.8,402.3,258.8,402.3z M266,492.2v-70.8c16.9-3.6,30.4-16,35.5-32.4c0-0.1,0.1-0.3,0.1-0.4c0.1-0.4,0.3-0.8,0.4-1.2c20.4,2.3,39.7,6.1,57.6,11.2c8.1,28.6,12.9,60.5,13.7,93.6H266z M393.3,492.2c-0.7-29.9-4.4-59.1-11-86.2c53,19.7,89.1,51.2,94.9,86.2H393.3z" />
                                                            <path d="M256,241.9c-54.3,0-98.5-44.2-98.5-98.5c0-54.3,44.2-98.5,98.5-98.5c54.3,0,98.5,44.2,98.5,98.5C354.5,197.8,310.3,241.9,256,241.9z M256,65c-43.2,0-78.4,35.2-78.4,78.5c0,43.2,35.2,78.4,78.4,78.4c43.3,0,78.5-35.2,78.5-78.4C334.5,100.2,299.3,65,256,65z" />
                                                            <path d="M420.1,348.2c-2.9,0-5.8-1.3-7.8-3.8l-0.1-0.1c-3.5-4.3-2.8-10.6,1.6-14.1c4.3-3.5,10.6-2.8,14.1,1.6l0.1,0.1c3.5,4.3,2.8,10.6-1.6,14.1C424.5,347.4,422.3,348.2,420.1,348.2z" />
                            </g>
                            </g>
                            </svg>
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP1"]}}</span>
                                                        <span v-if="obj_member.TRIP > 0" class="badge badge-pill badge-danger">{{ obj_member.TRIP }}</span> <i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>

                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 5}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <img src="../../../../assets/icons/last-best-ip.svg" width="16" />
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP5"]}}</span>
                                                        <span v-if="obj_member.TGBIP > 0" class="badge badge-pill badge-danger">{{ obj_member.TGBIP }}</span> <i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>

                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 2}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                            <path d="M9.6,512c-5.3,0-9.5-4.3-9.5-9.5V439c0-5.3,4.3-9.5,9.5-9.5h11.9v-51.8c0-5.3,4.3-9.5,9.5-9.5H42V182.7H9.6c-5.3,0-9.5-4.3-9.5-9.5v-61.3c0-3.8,2.3-7.4,5.8-8.9L252.3,0.7c1.1-0.5,2.4-0.7,3.7-0.7c1.3,0,2.5,0.2,3.7,0.7L506,103c3.6,1.5,5.9,4.9,5.9,8.9v61.3c0,5.3-4.3,9.5-9.5,9.5H470v185.4h10.9c5.3,0,9.5,4.3,9.5,9.5v51.8h11.9c5.3,0,9.5,4.3,9.5,9.5v63.4c0,5.3-4.3,9.5-9.5,9.5H9.6z M19.1,492.9h473.7v-44.3H19.1V492.9z M388.2,429.5h83.2v-42.3h-83.2V429.5z M122.4,368.1h10.9c5.3,0,9.5,4.3,9.5,9.5v51.8h226.3v-51.8c0-5.3,4.3-9.5,9.5-9.5h10.9V182.7H122.4V368.1z M40.6,429.5h83.2v-42.3H40.6V429.5zM408.7,368.1H451V182.7h-42.3V368.1z M61,368.1h42.3V182.7H61V368.1z M19.1,118.2v45.5h473.7v-45.5L256,19.9L19.1,118.2z" />
                                                            <path d="M164,121.4c-5.3,0-9.5-4.3-9.5-9.5c0-5.3,4.3-9.5,9.5-9.5h184c5.3,0,9.5,4.3,9.5,9.5c0,5.3-4.3,9.5-9.5,9.5H164z" />
                                                            <path d="M256,397.4c-5.3,0-9.5-4.3-9.5-9.5V376l-3.9-1.4c-16-5.7-26.8-20.9-26.8-37.9c0-5.3,4.3-9.5,9.5-9.5c5.3,0,9.5,4.3,9.5,9.5c0,11.7,9.5,21.1,21.1,21.1c11.7,0,21.1-9.5,21.1-21.1s-9.5-21.1-21.1-21.1c-22.2,0-40.2-18-40.2-40.2c0-17,10.8-32.2,26.8-37.9l3.9-1.4v-11.9c0-5.3,4.3-9.5,9.5-9.5c5.3,0,9.5,4.3,9.5,9.5v11.9l3.9,1.4c16,5.7,26.8,20.9,26.8,37.9c0,5.3-4.3,9.5-9.5,9.5s-9.5-4.3-9.5-9.5c0-11.7-9.5-21.1-21.1-21.1c-11.7,0-21.1,9.5-21.1,21.1s9.5,21.1,21.1,21.1c22.2,0,40.2,18,40.2,40.2c0,17-10.8,32.2-26.8,37.9l-3.9,1.4v11.9C265.5,393.2,261.3,397.4,256,397.4z" />
                                </svg>
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP2"]}}</span>
                                                        <span v-if="obj_member.TBA > 0" class="badge badge-pill badge-danger">{{ obj_member.TBA }}</span> <i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>

                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 6}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <img src="../../../../assets/icons/last-login-ip.svg" width="16" />
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP6"]}}</span>
                                                        <span v-if="obj_member.TLIP > 0" class="badge badge-pill badge-danger">{{ obj_member.TLIP }}</span> <i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>

                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 3}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                            <path d="M32,479.3v-0.1h-5.8C11.8,479.2,0,467.4,0,453V157.4c0-14.5,11.8-26.2,26.2-26.2h180.6c5.4,0,9.7,4.4,9.7,9.7c0,5.4-4.4,9.7-9.7,9.7H19.5v79h187.2c5.4,0,9.7,4.4,9.7,9.7s-4.4,9.7-9.7,9.7H19.5v210.4h473V338.1c0-5.4,4.4-9.7,9.7-9.7c5.4,0,9.7,4.4,9.7,9.7v114.9c0,14.5-11.8,26.2-26.2,26.2H32z" />
                                                            <path d="M75.4,347.9c-5.4,0-9.7-4.4-9.7-9.7c0-5.4,4.4-9.7,9.7-9.7h65.7c5.4,0,9.7,4.4,9.7,9.7c0,5.4-4.4,9.7-9.7,9.7H75.4z" />
                                                            <path d="M387.3,347.9c-1.7,0-3.4-0.4-4.9-1.3c-44.9-25.9-74.4-51.5-92.9-80.7c-18.4-29-26.9-63.5-26.9-108.4V91.9c0-3.9,2.3-7.5,5.9-9l114.9-49.3c1.2-0.5,2.5-0.8,3.9-0.8c1.4,0,2.7,0.3,3.9,0.8l114.9,49.3c3.6,1.5,5.9,5.1,5.9,9v65.7c0,45-8.5,79.4-26.9,108.4c-18.4,29.2-48,54.8-92.9,80.6C390.7,347.4,389,347.9,387.3,347.9z M387.3,327.4l3.6-2.7c74.9-45,101.4-88.7,101.4-167.1V98.3L387.2,53.1l-105,45.1v59.2c0,78.3,26.6,122,101.4,167.1L387.3,327.4z" />
                                                            <path d="M370.4,232.9c-3.1-0.2-5.8-1.7-7.6-4.3L330,179.3c-1.4-2.2-1.9-4.7-1.4-7.3c0.5-2.6,2-4.7,4.2-6.3c1.5-1,3.3-1.6,5.3-1.6c3.3,0,6.4,1.6,8.1,4.3l25.5,38.1l57.3-71.6c1.9-2.3,4.6-3.7,7.6-3.7c2.3,0,4.4,0.7,6.1,2.1c4.2,3.4,4.9,9.6,1.6,13.8l-65.6,82.1c-1.9,2.3-4.6,3.7-7.6,3.7H370.4z" />
                                </svg>
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP3"]}}</span>
                                                        <span v-if="obj_member.TBN > 0" class="badge badge-pill badge-danger">{{ obj_member.TBN }}</span><i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>

                                                <div class="col-6 pr-0">
                                                    <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: agi, i: id, u: obj_member.U, cf: 7}} : ''" style="color: rgb(0, 0, 0); display: flex; align-items: center;gap: 5px;position: relative;">
                                                        <div class="member-list-same-1">
                                                            <img src="../../../../assets/icons/last-system-ip.svg" width="16" />
                                                        </div>
                                                        <span class="">{{getLanguage["MEM"]["DUP7"]}}</span>
                                                        <span v-if="obj_member.TSI > 0" class="badge badge-pill badge-danger">{{ obj_member.TSI }}</span> <i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Register time -->
                                        <div class="col-12">
                                            <div class="subHeaderHR my-2" style="border-top: solid 2px rgb(229 229 229 / 50%);"></div>
                                            <div class="row">
                                                <div class="col-6" style="padding-right:7px">
                                                    <div class="card-body p-0">
                                                        <div class=""><a style="color: #000; font-size: 12px">{{this.getLanguage["MEM"]["RT"]}} :</a></div>
                                                        <div class="font-weight-bold my-0 mx-auto"><a style="color: #000; font-size: 11px">{{formatDateTime(obj_member.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY")}} ({{formatDateTime(obj_member.CTS, "YYYY-MM-DD HH:mm:ss", "HH:mm:ss a")}})</a></div>
                                                        <div class=""><a style="color: #000; font-size: 12px">{{this.getLanguage["MEM"]["LLTS"]}} :</a></div>
                                                        <div class="font-weight-bold my-0 mx-auto">
                                                            <a style="color: #000; font-size:11px" v-if="obj_member.LLTS">{{formatDateTime(obj_member.LLTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY")}} ({{formatDateTime(obj_member.LLTS, "YYYY-MM-DD HH:mm:ss", "HH:mm:ss a")}})</a>
                                                            <a style="color: #000; font-size:11px" v-else>{{this.getLanguage["DLSS"]["NA"]}}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-6" style="padding-right: 7px;">
                                                    <div class="card-body p-0">
                                                        <div class=""><a style="color: #000; font-size: 12px">{{this.getLanguage["MEM"]["RIP"]}} :</a></div>
                                                        <div class="font-weight-bold my-0 mx-auto">
                                                            <a target="_blank" :href="checkIpAddress(obj_member.CIP)" style="color: #000; font-size:11px" v-if="obj_member.CIP">{{obj_member.CIP}} ({{ renderLoginDetails(obj_member.IM) }})<i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i></a>
                                                            <a style="color: #000; font-size:11px" v-else>{{this.getLanguage["DLSS"]["NA"]}}</a>
                                                        </div>
                                                        <div class=""><a style="color: #000; font-size: 12px">{{this.getLanguage["MEM"]["LLIP"]}} :</a></div>
                                                        <div class="font-weight-bold my-0 mx-auto">
                                                            <a target="_blank" :href="checkIpAddress(obj_member.LLIP)" style="color: #000; font-size:11px" v-if="obj_member.LLIP">{{obj_member.LLIP}} ({{ renderLoginDetails(obj_member.IM) }})<i aria-hidden="true" class="fa fa-angle-right mx-1 dashHover" style="position:absolute;right:10px;font-size:15px"></i></a>
                                                            <a style="color: #000; font-size:11px" v-else>{{this.getLanguage["DLSS"]["NA"]}}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 col-lg-7 mb-2" style="padding-top: 0 !important">
                    <div class="row">
                        <!-- total wallet -->
                        <div class="mb-2" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-xl-12': 'col-12 col-lg-6 pr-lg-0'">
                            <div class="card theme-box-container border-radius-10 text-break border-brown-2 w-100 h-100">
                                <div class="row mx-0 card-body">
                                    <div class="wallet-icon">
                                        <img src="../../../../assets/images/wallet_bk.svg" style="width:28px;" />
                                    </div>

                                    <div class="d-flex" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-lg-4 px-0': 'col-12 px-0'">
                                        <div class="">
                                            <h6 class="card-title mb-0">{{this.getLanguage["MEM"]["CBL"]}}</h6>
                                            <h5 class="font-weight-bold text-blue m-0" style="font-size: 25px;">{{ formatNumber(obj_member.CBL, 2, obj_member.TOTLWTCS) }}</h5>
                                        </div>
                                    </div>

                                    <div class="" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-lg-8 px-0': 'd-none'" style="display: flex;flex-direction: column;border-left: 2px solid rgba(229, 229, 229, 0.47);">
                                        <div class="">
                                            <div class="tempScrollbar p-0" style="width:calc(100% - 13px);">
                                                <div class="col-5 card theme-box-container border-radius-10 text-break w-100 h-100" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showPokerVWalletArea">
                                                    <div class="card-body p-1">
                                                        <h6 class="card-title mb-0" style="font-size: 13px;">{{this.getLanguage["MEM"]["PVW"]}}<br /> <span v-if="obj_member.PVAN != ''">({{ obj_member.PVAN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.PVW>=0">{{ formatNumber(obj_member.PVW, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.PVW==-2">{{this.getLanguage["MEM"]["BBPV"]}}</h5>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showMegaGamingWalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["MGW"]}} <br /><span v-if="obj_member.PVAN != ''" :style="MegaGamingUserStatus(obj_member.MGUS)">({{ obj_member.MGAN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.MGW>=0">{{ formatNumber(obj_member.MGW, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.MGW==-1">{{this.getLanguage["MEM"]["MGGWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-if="obj_member.MGUS == 1" @click='showMegaGamingTransfer(100)'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">Mega888 Transfer</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-if="obj_member.MGUS == 1" @click='megaGamingBlock(100)'>
                                                                <i class="cil-ban"></i>
                                                                <span class="tooltiptext" style="bottom: 100%; left: -15% ">Mega888 Block User</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-else @click='megaGamingUnblock(100)'>
                                                                <i class="cil-action-undo"></i>
                                                                <span class="tooltiptext" style="bottom: 100%; left: 12%">Mega888 Unblock User</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showMegaV3GamingWalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["MV3W"]}}<br /><span v-if="obj_member.MV3GAN != ''" :style="MegaGamingUserStatus(obj_member.MV3GUS)">({{ obj_member.MV3GAN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.MV3GW>=0">{{ formatNumber(obj_member.MV3GW, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.MV3GW==-1">{{this.getLanguage["MEM"]["MV3GWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-if="obj_member.MV3GUS == 1" @click='showMegaGamingTransfer(106)'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">MegaV3 Transfer</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-if="obj_member.MV3GUS == 1" @click='megaGamingBlock(106)'>
                                                                <i class="cil-ban"></i>
                                                                <span class="tooltiptext" style="bottom: 100%; left: -15%">MegaV3 Block User</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-else @click='megaGamingUnblock(106)'>
                                                                <i class="cil-action-undo"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">MegaV3 Unblock User</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showPussy888WalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["PSW"]}}<br /><span v-if="obj_member.PVAN != ''" :style="Kiss918UserStatus(obj_member.P888US)">({{ obj_member.PAN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.PW>=0">{{ formatNumber(obj_member.PW, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.PW==-1">{{this.getLanguage["MEM"]["PGWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-if="obj_member.P888US == 1" @click='showPussy888Transfer()'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">Pussy888 Transfer</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" v-if="obj_member.P888US == 1" style="border: 0.1px solid;">
                                                                <i class="cil-ban" @click='Pussy888Disable()'></i>
                                                                <span class="tooltiptext" style="bottom: 100%; left: -15%">Pussy888 Disable User</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" v-if="obj_member.P888US != 1" style="border: 0.1px solid;">
                                                                <i class="cil-action-undo" @click='Pussy888Enable()'></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">Pussy888 Enable User</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showKiss918WalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["KW"]}}<br /> <span v-if="obj_member.K918AN != ''" :style="Kiss918UserStatus(obj_member.K918US)">({{ obj_member.K918AN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.K918W>=0">{{ formatNumber(obj_member.K918W, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.K918W==-1">{{this.getLanguage["MEM"]["KGWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" v-if="obj_member.K918US == 1" @click='showKiss918Transfer()'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">918Kiss Transfer</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" v-if="obj_member.K918US == 1" style="border: 0.1px solid;">
                                                                <i class="cil-ban" @click='Kiss918Disable()'></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:-15%">918Kiss Disable User</span>
                                                            </div>
                                                            <div class="member-list-same custom_tooltip mt-1" v-if="obj_member.K918US != 1" style="border: 0.1px solid;">
                                                                <i class="cil-action-undo" @click='Kiss918Enable()'></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">918Kiss Enable User</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showIG_GFCWalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["GW"]}}<br /> <span v-if="obj_member.IGGFCAN != ''">({{ obj_member.IGGFCAN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.IGGFCW>=0">{{ formatNumber(obj_member.IGGFCW, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.IGGFCW==-1">{{this.getLanguage["MEM"]["GGWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" @click='showIG_GFCTransfer()'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">IG Official Lottery Transfer</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showIG_LOTTERYWalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["SW"]}}<br /> <span v-if="obj_member.IGLOTTERYAN != ''">({{ obj_member.IGLOTTERYAN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.IGLOTTERYW>=0">{{ formatNumber(obj_member.IGLOTTERYW, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.IGLOTTERYW==-1">{{this.getLanguage["MEM"]["GGWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" @click='showIG_LOTTERYTransfer()'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">IG Instant Lottery Transfer</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showIG_LOTTOWalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["HW"]}}<br /> <span v-if="obj_member.IGLOTTOAN != ''">({{ obj_member.IGLOTTOAN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.IGLOTTOW>=0">{{ formatNumber(obj_member.IGLOTTOW, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.IGLOTTOW==-1">{{this.getLanguage["MEM"]["GGWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" @click='showIG_LOTTOTransfer()'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">IG Hong Kong Mark Six Transfer</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--
                                            <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showDG3D_FISHINGWalletArea">
                                                <div class="card-body p-2">
                                                    <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["DG3DFW"]}}<br /> <span v-if="obj_member.DG3D_FISHINGAN != ''">({{ obj_member.DG3D_FISHINGAN }})</span></h6>
                                                    <div class="d-flex no-gutters justify-content-between align-items-center">
                                                        <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.DG3D_FISHINGW>=0">{{ formatNumber(obj_member.DG3D_FISHINGW, 2, obj_member.TOTLWTCS) }}</h5>
                                                        <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.DG3D_FISHINGW==-1">{{this.getLanguage["MEM"]["GDG3DFWF"]}}</h5>
                                                    </div>
                                                    <div class="d-flex no-gutters align-items-center">
                                                        <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" @click='showDG3D_FISHINGTransfer()'>
                                                            <i class="fa fa-circle-dollar-to-slot"></i>
                                                            <span class="tooltiptext" style="bottom: 100%;left:12%">DG3D Fishing Lottery Transfer</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            -->
                                                <div class="col-5 px-0 card theme-box-container border-radius-10 text-break w-100 h-100 mr-2" style="background-color: #F7F8FC; border: 1px solid #F7F8FC;box-shadow:none;" v-if="showWICKET9WalletArea">
                                                    <div class="card-body p-2">
                                                        <h6 class="card-title mb-1" style="font-size: 13px;">{{this.getLanguage["MEM"]["WICKET9W"]}}<br /> <span v-if="obj_member.WICKET9AN != ''">({{ obj_member.WICKET9AN }})</span></h6>
                                                        <div class="d-flex no-gutters justify-content-between align-items-center">
                                                            <h5 class="font-weight-bold m-0 text-green1" v-if="obj_member.WICKET9W>=0">{{ formatNumber(obj_member.WICKET9W, 2, obj_member.TOTLWTCS) }}</h5>
                                                            <h5 class="font-weight-bold m-0 text-red1" v-if="obj_member.WICKET9W==-1">{{this.getLanguage["MEM"]["GDG3DFWF"]}}</h5>
                                                        </div>
                                                        <div class="d-flex no-gutters align-items-center">
                                                            <div class="member-list-same custom_tooltip mt-1" style="border: 0.1px solid;" @click='showWICKET9Transfer()'>
                                                                <i class="fa fa-circle-dollar-to-slot"></i>
                                                                <span class="tooltiptext" style="bottom: 100%;left:12%">9WICKET Transfer</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-12 col-xl-4 pr-xl-0': 'col-12 col-lg-6'">
                            <div class="card theme-box-container border-radius-10 text-break border-blue-1 w-100 h-100">
                                <div class="card-body">
                                    <div class="money-flow-icon">
                                        <img src="../../../../assets/images/money-flow.svg" style="width:28px;" />
                                    </div>

                                    <div class="">
                                        <h6 class="card-title mb-0">
                                            {{this.getLanguage["MEM"]["NPNL"]}}

                                            <div class="custom_tooltip d-inline">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2" style=" width: 200px;">{{getLanguage["MEM"]["NPNLD"]}}</span>
                                            </div>
                                        </h6>
                                        <h5 :class="obj_member.TWLA + obj_member.BA+obj_member.AFF + obj_member.ARA + obj_member.DLSA + obj_member.PA + obj_member.TNMTA < 0? 'text-red1': 'text-green1'" class="font-weight-bold m-0" style=" word-break: break-all;">{{ formatNumber(obj_member.TWLA + obj_member.BA +obj_member.AFF+ obj_member.ARA + obj_member.DLSA + obj_member.PA + obj_member.TNMTA, 2, obj_member.TOTLWTCS) }}</h5>
                                        <div class="subHeaderHR" style="border-top: solid 2px rgb(229 229 229 / 50%); margin-top: 0.5rem;"></div>
                                    </div>
                                    <div class="">
                                        <h6 class="card-title mb-0">{{this.getLanguage['DB']['TNPNL']}}</h6>
                                        <h5 :class="obj_member.TDWLA + obj_member.TDBA +obj_member.TDAFF + obj_member.TDARA + obj_member.TDDLSA + obj_member.TDPA + obj_member.TTNMTA < 0? 'text-red1': 'text-green1'" class="font-weight-bold m-0" style=" word-break: break-all;">{{ formatNumber(obj_member.TDWLA + obj_member.TDBA + obj_member.TDAFF+ obj_member.TDARA + obj_member.TDDLSA + obj_member.TDPA + obj_member.TTNMTA, 2, obj_member.TOTLWTCS) }}</h5>
                                        <div class="subHeaderHR" style="border-top: solid 2px rgb(229 229 229 / 50%); margin-top: 0.5rem;"></div>
                                    </div>
                                    <div class="">
                                        <!--Sponsored OTSB-->
                                        <h6 class="card-title mb-0">{{this.getLanguage['BETRPT']['SPRWL']}}</h6>
                                        <h5 :class="obj_member.SPRWL < 0? 'text-red1': 'text-green1'" class="font-weight-bold m-0" style=" word-break: break-all;">{{ formatNumber(obj_member.SPRWL, 2, obj_member.TOTLWTCS) }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-12 col-xl-4 pr-xl-0': 'col-12 col-lg-6 pr-lg-0'">
                            <div class="card theme-box-container border-radius-10 text-break border-purple-2 w-100 h-100">
                                <div class="card-body">
                                    <div class="turnover-icon">
                                        <img src="../../../../assets/images/betting.svg" style="width:28px;" />
                                    </div>
                                    <div class="">
                                        <h6 class="card-title mb-0">{{this.getLanguage["MEM"]["TT"]}}</h6>
                                        <h5 class="font-weight-bold m-0" style=" word-break: break-all;">{{ formatNumber(obj_member.TT, 2, obj_member.TOTLWTCS) }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-12 col-xl-4': 'col-12 col-lg-6'">
                            <div class="card theme-box-container border-radius-10 text-break border-red-2 w-100 h-100" style="border: 5px solid #ff2f00  !important">
                                <div class="card-body">
                                    <div class="withdraw-icon" style="background: #ff2f00 !important ">
                                        <img src="../../../../assets/images/eligible.svg" style="width:28px;" />
                                    </div>
                                    <div class="">
                                        <h6 class="card-title mb-0">{{this.getLanguage['MEM']['EWA']}}</h6>
                                        <h5 class="font-weight-bold m-0">{{ formatNumber(obj_member.RTO, 2, obj_member.TOTLWTCS) }}</h5>
                                        <div class="subHeaderHR" style="border-top: solid 2px rgb(229 229 229 / 50%); margin-top: 0.5rem;"></div>
                                    </div>
                                    <div class="">
                                        <h6 class="card-title mb-0" style="color: #ff2f00">{{this.getLanguage['MEM']['WA']}} {{ formatNumber(obj_member.WA, 2, obj_member.TOTLWTCS) }}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-12 col-xl-4 pr-xl-0': 'col-12 col-lg-6 pr-lg-0'">
                            <div class="card theme-box-container border-radius-10 text-break border-green-2 w-100 h-100">
                                <div class="card-body">
                                    <div class="trophy-icon">
                                        <img src="../../../../assets/images/trophy_bk.svg" style="width:28px;" />
                                    </div>
                                    <div class="">
                                        <h6 class="card-title mb-0">{{this.getLanguage["DB"]["DDPT"]}}</h6>
                                        <h5 class="font-weight-bold m-0 text-green1" style=" word-break: break-all;">{{ formatNumber(obj_member.DD, 2, obj_member.TOTLWTCS) }}</h5>
                                        <div class="subHeaderHR" style="border-top: solid 2px rgb(229 229 229 / 50%); margin-top: 0.5rem;"></div>
                                    </div>
                                    <div class="">
                                        <div class="">
                                            <h6 class="card-title mb-0">{{this.getLanguage["DB"]["DDPT"]}} (#)</h6>
                                            <h5 class="font-weight-bold m-0" style=" word-break: break-all;">{{ formatNumber(obj_member.TDDC, 0) }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2" :class="(showPokerVWalletArea || showMegaGamingWalletArea || showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea)? 'col-12 col-xl-4 pr-xl-0': 'col-12 col-lg-6'">
                            <div class="card theme-box-container border-radius-10 text-break border-red-2 w-100 h-100">
                                <div class="card-body">
                                    <div class="withdraw-icon">
                                        <img src="../../../../assets/images/withdraw_bk.svg" style="width:28px;" />
                                    </div>
                                    <div class="">
                                        <h6 class="card-title mb-0">{{this.getLanguage["DB"]["DW"]}}</h6>
                                        <h5 class="font-weight-bold m-0 text-red1" style=" word-break: break-all;">{{ formatNumber(obj_member.DW, 2, obj_member.TOTLWTCS) }}</h5>
                                        <div class="subHeaderHR" style="border-top: solid 2px rgb(229 229 229 / 50%); margin-top: 0.5rem;"></div>
                                    </div>
                                    <div class="">
                                        <h6 class="card-title mb-0">{{this.getLanguage["DB"]["DW"]}} (#)</h6>
                                        <h5 class="font-weight-bold m-0" style=" word-break: break-all;">{{ formatNumber(obj_member.TDWC, 0) }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="member30days-wrapper">
                                <div class="box">
                                    <h6 class="card-title">{{this.getLanguage['MEM']['AD1']}}</h6>
                                    <div class="d-flex no-gutters justify-content-between align-items-center">
                                        <h5 class="font-weight-bold m-0 text-green1">{{ formatNumber(obj_member.AD, 2, obj_member.TOTLWTCS) }}</h5>
                                    </div>
                                </div>
                                <div class="box">
                                    <h6 class="card-title">{{this.getLanguage['CPR']['DEP']}}</h6>
                                    <div class="d-flex no-gutters justify-content-between align-items-center">
                                        <h5 class="font-weight-bold m-0 text-green1">{{ formatNumber(obj_member.SOD, 2, obj_member.TOTLWTCS) }}</h5>
                                    </div>
                                </div>
                                <div class="box">
                                    <h6 class="card-title">{{this.getLanguage['MEM']['COD']}}</h6>
                                    <div class="d-flex no-gutters justify-content-between align-items-center">
                                        <h5 class="font-weight-bold m-0 text-blue-3">{{ formatNumber(obj_member.COD, 0) }}</h5>
                                    </div>
                                </div>
                                <div class="box">
                                    <h6 class="card-title"> {{this.getLanguage['CPR']['WD']}}</h6>
                                    <div class="d-flex no-gutters justify-content-between align-items-center">
                                        <h5 class="font-weight-bold m-0 text-red1">{{ formatNumber(obj_member.SOW, 2, obj_member.TOTLWTCS) }}</h5>
                                    </div>
                                </div>
                                <div class="box">
                                    <h6 class="card-title"> {{this.getLanguage['MEM']['COW']}}</h6>
                                    <div class="d-flex no-gutters justify-content-between align-items-center">
                                        <h5 class="font-weight-bold m-0 text-blue-3">{{ formatNumber(obj_member.COW, 0) }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TABLE -->
            <div class="row">
                <div class="col-12 col-lg-6  pt-2">
                    <div class="custom-table-wrapper">
                        <table class="custom-table custom-tableMP text-center afb-blue">
                            <thead>
                                <tr>
                                    <th class="text-left">{{this.getLanguage['MEM']['TRDS']}}</th>
                                    <th class="text-right w-25">{{this.getLanguage['MEM']['A']}} ({{ obj_member.ICT ? obj_member.TOTLWTCS : obj_member.IC }})</th>
                                    <th>{{this.getLanguage['MEM']['TTS']}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><!----></tr>
                                <tr class="">
                                    <td class="text-left text-white bg-green-2">{{this.getLanguage['MEM']['LDA']}}</td>
                                    <td class="text-right text-green-2">{{ formatNumber(obj_member.LDA, 2, obj_member.TOTLWTCS) }}</td>
                                    <td>
                                        <span v-if="obj_member.LDTS==null">-</span>
                                        <span>{{ formatDateTime(obj_member.LDTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss a") }}</span>
                                    </td>
                                </tr>
                                <tr class="">
                                    <td class="text-left text-white bg-green-2">{{this.getLanguage['MEM']['TDA']}}</td>
                                    <td class="text-right text-green-2">{{ formatNumber(obj_member.TD, 2, obj_member.TOTLWTCS) }}</td>
                                    <td>
                                        <span v-if="obj_member.LDTS==null">-</span>
                                        <span>{{ formatDateTime(obj_member.LDTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss a") }}</span>
                                    </td>
                                </tr>
                                <tr class="">
                                    <td class="text-left text-white bg-green-2">{{this.getLanguage['MEM']['TTOA']}}</td>
                                    <td class="text-right">{{ formatNumber(obj_member.TTO, 2, obj_member.TOTLWTCS) }}</td>
                                    <td>
                                        <span v-if="obj_member.TTOTS==null">-</span>
                                        <span>{{ formatDateTime(obj_member.TTOTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss a") }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-12 col-lg-6  pt-2">
                    <div class="custom-table-wrapper">
                        <table class="custom-table custom-tableMP text-center afb-blue">
                            <thead>
                                <tr>
                                    <th class="text-left">{{this.getLanguage['MEM']['TRDS']}}</th>
                                    <th class="text-right w-25">{{this.getLanguage['MEM']['A']}} ({{ obj_member.ICT ? obj_member.TOTLWTCS : obj_member.IC }})</th>
                                    <th>{{this.getLanguage['MEM']['TTS']}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><!----></tr>
                                <tr class="">
                                    <td class="text-left bg-red-2 text-white">{{this.getLanguage['MEM']['LWA']}}</td>
                                    <td class="text-right text-red1">{{formatNumber(obj_member.LWA, 2, obj_member.TOTLWTCS)}}</td>
                                    <td>
                                        <span v-if="obj_member.LWTS==null">-</span>
                                        <span>{{ formatDateTime(obj_member.LWTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss a") }}</span>
                                    </td>
                                </tr>
                                <tr class="">
                                    <td class="text-left bg-red-2 text-white">{{this.getLanguage['MEM']['CKMW']}}</td>
                                    <td class="text-right text-red1">{{formatNumber(obj_member.TW, 2, obj_member.TOTLWTCS)}}</td>
                                    <td>
                                        <span v-if="obj_member.LWTS==null">-</span>
                                        <span>{{ formatDateTime(obj_member.LWTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss a") }}</span>
                                    </td>
                                </tr>
                                <tr class="">
                                    <td class="text-left bg-red-2 text-white">{{this.getLanguage['MEM']['TBCA']}}</td>
                                    <td class="text-right">{{formatNumber(obj_member.BA + obj_member.ARA + obj_member.DLSA+ obj_member.AFF + obj_member.PA + obj_member.TNMTA, 2, obj_member.TOTLWTCS)}}</td>
                                    <td>
                                        <span v-if="obj_member.BATS==null">-</span>
                                        <span>{{ formatDateTime(obj_member.BATS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss a") }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="col-12  pt-2">
                    <div class="btn-group d-block">
                        <CButton @click="ShowCollapse(2)"
                                 color="primary"
                                 class="mb-2" :class="Promocollapse ? 'active' : ''" v-if="checkModuleAccess('PAP', 'P', constAccessType.view)||checkModuleAccess('LR', 'R', constAccessType.view)||checkModuleAccess('DLSR', 'R', constAccessType.view)">
                            {{this.getLanguage['MEM']['PROMO']}}
                        </CButton>
                        <CButton @click="ShowCollapse(3)"
                                 color="primary"
                                 class="mb-2" :class="Gamecollapse ? 'active' : ''">
                            {{this.getLanguage['MEM']['GAME']}}
                        </CButton>
                        <CButton @click="ShowCollapse(4)"
                                 color="primary"
                                 class="mb-2" :class="Transcollapse ? 'active' : ''">
                            {{this.getLanguage['MEM']['TRANS']}}
                        </CButton>
                        <CButton @click="ShowCollapse(5)"
                                 color="primary"
                                 class="mb-2" :class="Affiliatecollapse ? 'active' : ''">
                            {{this.getLanguage['SMB']['AFF']}}
                        </CButton>
                        <CButton @click="ShowCollapse(6)"
                                 color="primary"
                                 class="mb-2" :class="logcollapse ? 'active' : ''" v-if="checkModuleAccess('MLO', 'L', constAccessType.view)">
                            {{this.getLanguage['LOGRPT']['MLOG']}}
                        </CButton>
                        <CButton @click="ShowCollapse(7)"
                                 color="primary"
                                 class="mb-2" :class="PokerVcollapse ? 'active' : ''" v-if="showPokerVWalletArea || showMegaGamingWalletArea ||showMegaV3GamingWalletArea || showPussy888WalletArea || showKiss918WalletArea || showIG_GFCWalletArea || showIG_LOTTERYWalletArea || showIG_LOTTOWalletArea || showWICKET9WalletArea">
                            {{this.getLanguage['MEM']['GTRAN']}}
                        </CButton>
                        <CButton @click="ShowCollapse(8)"
                                 color="primary"
                                 class="mb-2" :class="CryptoWalletcollapse ? 'active' : ''" v-if="obj_member.ICT">
                            {{this.getLanguage['MEM']['CW']}}
                        </CButton>
                        <CButton @click="ShowCollapse(9)"
                                 color="primary"
                                 class="mb-2" :class="PromoPayoutcollapse ? 'active' : ''">
                            {{this.getLanguage['MEM']['PPPT']}}
                        </CButton>
                        <CButton @click="ShowCollapse(1)"
                                 color="primary"
                                 class="mb-2" :class="Profilecollapse ? 'active' : ''" v-if="((obj_member.AT == 3 && obj_member.IPV == 1 && obj_member.AGI == curAGI) || (obj_member.AT == 4 && obj_member.IPV == 1 && obj_member.SAGI == curAGI)|| obj_member.IPV == 0 || this.getUserInfo.AT == 0)">
                            {{this.getLanguage['MEM']['CKMB']}}
                        </CButton>
                    </div>

                    <div style="margin-bottom:10px;">
                        <!--promotion-->
                        <CCollapse :show="Promocollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div class='m-0' v-if="this.checkModuleAccess('PAP', 'P', constAccessType.view)">
                                        <header class="table-header" style="top:0px">
                                            <strong>{{this.getLanguage['MEM']['CKMAP']}}</strong>
                                        </header>
                                        <table class='custom-table custom-tableMP afb-blue'>
                                            <thead>
                                                <tr>
                                                    <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                    <th style="top:0px">{{ this.getLanguage["PM"]["RS"] }}</th>
                                                    <th style="top:0px">{{ this.getLanguage["PM"]["PCD"] }}</th>
                                                    <!--<th style="top:0px">{{ this.getLanguage["MEM"]["TI"] }}</th>-->

                                                    <th class="tableCtnRight" style="top:0px">{{ this.getLanguage["PM"]["PA"] }}</th>
                                                    <th class="tableCtnRight" style="top:0px">{{ this.getLanguage["MEM"]["BOB"] }}</th>
                                                    <th class="tableCtnRight" style="top:0px">{{ this.getLanguage["PM"]["TO"] }}</th>
                                                    <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["NOS"] }}</th>
                                                    <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}</th>
                                                    <!--<th style="top:0px">{{ this.getLanguage["GL"]["CT"] }}</th>-->

                                                    <th style="top:0px">{{ this.getLanguage["PM"]["APPTS"] }}</th>
                                                    <th style="top:0px">{{ this.getLanguage["MEM"]["PTTS"] }}</th>

                                                    <th style="top:0px">{{ this.getLanguage["MTA"]["OWN"] }}</th>
                                                    <!--<th style="top:0px">{{ this.getLanguage["GL"]["IP"] }}</th>-->
                                                </tr>

                                            </thead>
                                            <tbody>

                                                <tr v-if="arr_PromotionReportList.length == 0">
                                                    <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>

                                                </tr>

                                                <tr v-for="(data,index) in arr_PromotionReportList">
                                                    <td class="tableCtnNo">{{ index + 1 }}</td>
                                                    <td>
                                                        <span class="grid-line" :style="checkStatus(data.RS)">
                                                            {{ renderStatus(data.RS) }}
                                                        </span>
                                                        <span class="grid-line rejectReason" v-if="data.RS==3">{{ renderRejectReason(data.RR) }}</span>
                                                    </td>
                                                    <td>{{ data.PC }}</td>
                                                    <!--<td>{{ data.R }}</td>-->
                                                    <td class="tableCtnRight">

                                                        {{ formatNumber(((data.PG==22 || data.PG==24 || data.PG==32 || data.PG==34) && data.WTA>data.ATA)?'-':data.BA, 2, data.CS) }}
                                                        <div class="custom_tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 promotion-amount-tooltip">
                                                                <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["TBA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.TBA, 2, data.CS) }}</span></div>
                                                                <div v-if="data.DA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["DA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.DA, 2, data.CS) }}</span></div>
                                                                <div v-if="data.BA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["PA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.BA, 2, data.CS) }}</span></div>
                                                                <div v-if="data.FBA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["CF"] }} :</span><span class="tooltip-val">{{ formatNumber(data.FBA, 2, data.CS) }}</span></div>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td class="tableCtnRight">
                                                        <span class="grid-line">{{ getLanguage["PM"]["WBB"] }} : {{ formatNumber(data.WBB, 2, data.CS) }}</span>
                                                        <span class="grid-line" v-if="data.BBB > 0">{{ getLanguage["PM"]["BBB"] }} : {{ formatNumber(data.BBB, 2, data.CS) }}</span>
                                                    </td>
                                                    <td class="tableCtnRight">
                                                        {{ formatNumber(data.ATA, 2, data.CS) }} /{{ formatNumber(data.WTA, 2, data.CS) }}
                                                        <div class="custom_tooltip" v-if="data.FWTA > 0">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 promotion-amount-tooltip">
                                                                <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["CF"] }} :</span><span class="tooltip-val">{{ formatNumber(data.FWTA, 2, data.CS) }}</span></div>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td class='kema-eft tableCtnRight' @click="viewFSDetail(data)">
                                                        <span v-if="data.FSID > 0" class="grid-line">
                                                            {{ data.FS }}
                                                            <div class="float-right ml-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                                                </svg>
                                                            </div>
                                                        </span>
                                                        <span v-else class="grid-line">-</span>
                                                    </td>
                                                    <td>
                                                        <!--Spin Winning-->
                                                        <span v-if="data.FSID > 0" class="grid-line tableCtnRight">{{formatNumber(data.FSWA, 2,data.CS)}}</span>
                                                        <span v-else class="grid-line tableCtnRight">-</span>
                                                    </td>
                                                    <!--<td>{{ formatDate(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>-->

                                                    <td>{{ formatDate(data.ATS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>

                                                    <td>{{ formatDate(data.ETS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>

                                                    <td>{{ data.AT }}</td>
                                                    <!--<td>{{ data.AIP }}</td>-->

                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div class='m-0' v-if="this.checkModuleAccess('PAP', 'P', constAccessType.view)">
                                        <header class="table-header">
                                            <strong>{{this.getLanguage['MEM']['CKMP']}}</strong>
                                        </header>
                                        <table class='custom-table custom-tableMP afb-blue'>
                                            <thead>
                                                <tr>
                                                    <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                    <th>{{ this.getLanguage["PM"]["RS"] }}</th>
                                                    <th>{{ this.getLanguage["PM"]["PCD"] }}</th>
                                                    <th class="tableCtnRight">{{ this.getLanguage["PM"]["PA"] }}</th>
                                                    <th>{{ this.getLanguage["MEM"]["BOB"] }}</th>
                                                    <th class="tableCtnRight">{{ this.getLanguage["PM"]["TO"] }}</th>
                                                    <th class="tableCtnRight">{{ this.getLanguage["PM"]["FBA"] }}</th>
                                                    <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["NOS"] }}</th>
                                                    <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}</th>
                                                    <th>{{ this.getLanguage["PM"]["APPTS"] }}</th>
                                                    <th>{{ this.getLanguage["PM"]["CLOTS"] }}</th>
                                                    <th>{{ this.getLanguage["MEM"]["PTTS"] }}</th>
                                                    <th>{{ this.getLanguage["MTA"]["OWN"] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="arr_PromotionHistoryReportList.length == 0">
                                                    <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                </tr>
                                                <tr v-for="(data,index) in arr_PromotionHistoryReportList">
                                                    <td class="tableCtnNo">{{ index + 1 }}</td>
                                                    <td>
                                                        <span class="grid-line" :style="checkStatus(data.RS)">
                                                            {{ renderStatus(data.RS) }}
                                                        </span>
                                                        <span class="grid-line rejectReason" v-if="data.RS==3">{{ renderRejectReason(data.RR) }}</span>
                                                    </td>
                                                    <td>{{ data.PC }}</td>
                                                    <td class="tableCtnRight">
                                                        {{ formatNumber(((data.PG==22 || data.PG==24 || data.PG==32 || data.PG==34) && data.WTA>data.ATA)?'-':data.BA, 2, data.CS) }}
                                                        <div class="custom_tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 promotion-amount-tooltip">
                                                                <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["TBA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.TBA, 2, data.CS) }}</span></div>
                                                                <div v-if="data.DA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["DA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.DA, 2, data.CS) }}</span></div>
                                                                <div v-if="data.BA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["PA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.BA, 2, data.CS) }}</span></div>
                                                                <div v-if="data.FBA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["CF"] }} :</span><span class="tooltip-val">{{ formatNumber(data.FBA, 2, data.CS) }}</span></div>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td class="tableCtnRight">
                                                        <span class="grid-line">{{ getLanguage["PM"]["WBB"] }} : {{ formatNumber(data.WBB, 2, data.CS) }}</span>
                                                        <span class="grid-line" v-if="data.BBB > 0">{{ getLanguage["PM"]["BBB"] }} : {{ formatNumber(data.BBB, 2, data.CS) }}</span>
                                                    </td>
                                                    <td class="tableCtnRight">
                                                        {{ formatNumber(data.ATA, 2, data.CS) }} /{{ formatNumber(data.WTA, 2, data.CS) }}
                                                        <div class="custom_tooltip" v-if="data.FWTA > 0">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 promotion-amount-tooltip">
                                                                <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["CF"] }} :</span><span class="tooltip-val">{{ formatNumber(data.FWTA, 2, data.CS) }}</span></div>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td class="tableCtnRight">
                                                        {{ formatNumber(data.RA, 2, data.CS) }}
                                                        <div class="custom_tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 promotion-amount-tooltip">
                                                                <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["BABC"] }} :</span><span class="tooltip-val">{{ formatNumber(data.BABC, 2, data.CS) }}</span></div>
                                                                <div><span class="tooltip-label">{{ getLanguage["PM"]["FBA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.RA, 2, data.CS) }}</span></div>
                                                                <div><span class="tooltip-label">{{ getLanguage["PM"]["RTA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.RTMA, 2, data.CS) }}</span></div>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td class='kema-eft tableCtnRight' @click="viewFSDetail(data)">
                                                        <span v-if="data.FSID > 0" class="grid-line">
                                                            {{ data.FS }}
                                                            <div class="float-right ml-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                                                </svg>
                                                            </div>
                                                        </span>
                                                        <span v-else class="grid-line">-</span>
                                                    </td>
                                                    <td>
                                                        <!--Spin Winning-->
                                                        <span v-if="data.FSID > 0" class="grid-line tableCtnRight">{{formatNumber(data.FSWA, 2,data.CS)}}</span>
                                                        <span v-else class="grid-line tableCtnRight">-</span>
                                                    </td>
                                                    <td>{{ formatDate(data.ATS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    <td>
                                                        <span v-if="data.RS >= 4 && data.RS <= 9 "> {{ formatDate(data.CLOTS, "YYYY-MM-DDTHH:mm:ss","DD MMM YYYY HH:mm:ss") }}</span>
                                                        <span v-else>-</span>
                                                    </td>
                                                    <td>{{ formatDate(data.ETS, "YYYY-MM-DD HH:mm:ss","DD MMM YYYY HH:mm:ss") }}</td>
                                                    <td>{{(data.AT=='sys||promoturnover' || data.AT=='sys||promo')?'sys||approved':data.AT }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class='m-0' v-if="this.checkModuleAccess('LR', 'R', constAccessType.view)">
                                        <header class="table-header" :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)?'top:0px':''">
                                            <strong>{{this.getLanguage['SMB']['LYT']}}</strong>
                                        </header>
                                        <table class='custom-table custom-tableMP afb-blue'>
                                            <thead>
                                                <tr>
                                                    <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                    <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)?'top:0px':''">{{ this.getLanguage["MEM"]["LPN"] }}</th>
                                                    <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)?'top:0px':''">{{ this.getLanguage["N"]["F"] }}</th>
                                                    <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)?'top:0px':''">{{ this.getLanguage["N"]["T"] }}</th>
                                                    <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)?'top:0px':''" class="tableCtnRight">{{ this.getLanguage["PM"]["PA"] }}</th>
                                                    <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)?'top:0px':''" class="tableCtnRight">{{ this.getLanguage["MLY"]["AA"] }}</th>
                                                    <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)?'top:0px':''">{{this.getLanguage['LR']['CT']}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="arr_AutoRebateReportList.length == 0">
                                                    <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                </tr>
                                                <tr v-for="(data,index) in arr_AutoRebateReportList">
                                                    <td class="tableCtnNo">{{ index + 1 }}</td>
                                                    <td>{{ data.LN }}</td>
                                                    <td>{{ formatDate(data.SF, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    <td>{{ formatDate(data.ET, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.CS) }}</td>
                                                    <td class="tableCtnRight kema-eft">
                                                        <a href="#" @click="viewARDetail(data)" class="m-1">
                                                            {{ formatNumber(data.ACA, 2, data.CS) }}
                                                            <div class="float-right">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                                                </svg>
                                                            </div>
                                                        </a>
                                                    </td>
                                                    <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                </tr>
                                                <!--<tr v-for="(data,index) in arr_TotalAutoRebate">
                                                    <td colspan="4">{{ getLanguage["MEM"]["CKMTTL"] }}</td>
                                                    <td class="tableCtnRight">{{ formatNumber(data.TBA, 2, data.CS) }}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>-->
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="this.checkModuleAccess('DLSR', 'R', constAccessType.view)">
                                        <div class='m-0'>
                                            <header class="table-header" :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)&&!this.checkModuleAccess('LR', 'R', constAccessType.view)?'top:0px':''">
                                                <strong>{{ this.getLanguage["MEM"]["REWARD"] }}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                        <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)&&!this.checkModuleAccess('LR', 'R', constAccessType.view)?'top:0px':''">{{ this.getLanguage["PPS"]["PN"] }}</th>
                                                        <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)&&!this.checkModuleAccess('LR', 'R', constAccessType.view)?'top:0px':''">{{ this.getLanguage["MEM"]["ED"] }}</th>
                                                        <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)&&!this.checkModuleAccess('LR', 'R', constAccessType.view)?'top:0px':''">{{ this.getLanguage["MEM"]["GP"] }}</th>
                                                        <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)&&!this.checkModuleAccess('LR', 'R', constAccessType.view)?'top:0px':''">{{ this.getLanguage["MEM"]["FS"] }}</th>
                                                        <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)&&!this.checkModuleAccess('LR', 'R', constAccessType.view)?'top:0px':''" class="tableCtnRight">{{ this.getLanguage["MEM"]["FC"] }}</th>
                                                        <th :style="!this.checkModuleAccess('PAP', 'P', constAccessType.view)&&!this.checkModuleAccess('LR', 'R', constAccessType.view)?'top:0px':''" class="tableCtnRight">{{ this.getLanguage["PM"]["PA"] }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_DLSReportList.length == 0">

                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_DLSReportList">
                                                        <td class="tableCtnNo">{{ index + 1 }}</td>
                                                        <td>{{ data.PN }}</td>
                                                        <td>{{ formatDate(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                        <td>
                                                            <span v-if="data.PN != null && data.PN != ''">{{ renderProviderName(data.GPN) }}</span>
                                                            <span v-else>{{ getLanguage['GL']['ALL'] }}</span>
                                                        </td>
                                                        <td v-if="data.PG == 2" class='kema-eft' @click="viewDLSDetail(data)">
                                                            <span class="grid-line">
                                                                {{ data.FS }}
                                                                <div class="float-right">

                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                                                    </svg>
                                                                </div>
                                                            </span>
                                                        </td>
                                                        <td v-else>
                                                            <span class="grid-line">-</span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span v-if="data.CA>0">{{ formatNumber(data.CA, 2, data.CS) }}</span>
                                                            <span v-else>-</span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span v-if="data.BA>0">{{ formatNumber(data.BA, 2, data.CS) }}</span>
                                                            <span v-else>-</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--Game History-->
                        <CCollapse :show="Gamecollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div>
                                        <div class='mb-3'>
                                            <header class="table-header gh-mobile" style="top:0px; align-items:flex-end; justify-content: flex-start;">
                                                <strong>
                                                    {{this.getLanguage['MEM']['CKMT']}}

                                                    <span style="margin:0px 10px">
                                                        <!--Today Game Transaction-->
                                                        <CButton color="primary" style="margin-bottom:0!important;" class="mb-2" :class="showFilterGT == null ? 'active' : ''" size="sm" @click="getTransactionData()">
                                                            {{getLanguage["MEM"]["TODAY"]}}
                                                        </CButton>
                                                        <span style="border-right: 1px solid black; height: 15px; display: inline-block; margin: -3px 3px;"></span>
                                                        <!--All Time Game Transaction-->
                                                        <CButton color="primary" style="margin-bottom:0!important;" class="mb-2" :class="showFilterGT == 1 ? 'active' : ''" size="sm" @click="getTransactionData(1)">
                                                            {{getLanguage["MEM"]["AT"]}}
                                                        </CButton>
                                                    </span>
                                                </strong>

                                                <!--Start Date-->
                                                <span style="max-width: 200px; margin: 0px 10px;" class='searchCol'>
                                                    <span style="font-size: .76563rem" class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                                    <date-range-picker :show-dropdowns="true"
                                                                       opens="right"
                                                                       :auto-apply="true"
                                                                       v-model="GH_Date.FV"
                                                                       @update="selectDateRangePickerUpdateEvent"
                                                                       :ranges="getDefaultDateRange()">
                                                        <div slot="input" slot-scope="picker">
                                                            <div v-if="GH_Date.FV.startDate != ''">
                                                                <CInput size="sm"
                                                                        :value="GH_Date.FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                        @change="DateTimeChange('SD',$event)" />
                                                            </div>
                                                            <div v-else>
                                                                <CInput size="sm"
                                                                        @change="DateTimeChange('SD',$event)" />
                                                            </div>
                                                        </div>
                                                    </date-range-picker>
                                                    <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter(showPrevFilterGT == null ? null : 1)">
                                                        <CIcon name="cilX" size="sm"></CIcon>
                                                    </CButton>
                                                </span>

                                                <!--End Date-->
                                                <span style="max-width: 200px; margin: 0px 10px;" class='searchCol'>
                                                    <span style="font-size: .76563rem" class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                                    <date-range-picker :show-dropdowns="true"
                                                                       opens="left"
                                                                       :auto-apply="true"
                                                                       v-model="GH_Date.FV"
                                                                       @update="selectDateRangePickerUpdateEvent"
                                                                       :ranges="getDefaultDateRange()">
                                                        <div slot="input" slot-scope="picker">
                                                            <div v-if="GH_Date.FV.endDate != ''">
                                                                <CInput size="sm"
                                                                        :value="GH_Date.FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                        @change="DateTimeChange('ED',$event)" />
                                                            </div>
                                                            <div v-else>
                                                                <CInput size="sm"
                                                                        @change="DateTimeChange('ED',$event)" />
                                                            </div>
                                                        </div>
                                                    </date-range-picker>
                                                    <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter(showPrevFilterGT == null ? null : 1)">
                                                        <CIcon name="cilX" size="sm"></CIcon>
                                                    </CButton>
                                                </span>

                                                <span style="margin: 0px 10px;" class='searchBtnCol'>
                                                    <CButton v-shortkey="['enter']" @shortkey="" ref="search" class='searchBtn' size="sm" block color="success" @click="getTransactionData(2)"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                                                </span>

                                                <div class="pageBtn" v-if="bool_showAllTransaction">
                                                    <button @click="prevPage()">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page"
                                                           type="number"
                                                           @keyup="int_Page = int_Page" />
                                                    <span class="tableItemCount">/ {{int_TP}}</span>
                                                    <button @click="nextPage()">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                            </header>
                                            <div class="custom-table-wrapper">

                                                <table class='custom-table custom-tableMP afb-blue'>
                                                    <thead>
                                                        <tr>
                                                            <!--Provider-->
                                                            <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                            <th class="tableCtnLeft" style="top:0px;position:static">
                                                                {{ getLanguage['MEM']['CKMPVD'] }}
                                                            </th>
                                                            <th class="tableCtnLeft" style="top:0px;position:static" v-if="getUserInfo.AT == 0">
                                                                <!--Provider BO Username-->
                                                                <span>{{getLanguage["MEM"]["PBOU"]}} ({{obj_member.B26}})</span>
                                                                <div class="custom_tooltip">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext" style="bottom: -120%;background: black;">{{getLanguage["HELP"]["PBOU"]}}</span>
                                                                </div>
                                                            </th>
                                                            <!--Turnover Amount-->
                                                            <th class="tableCtnRight" style="top:0px; position:static;">
                                                                {{this.getLanguage['MEM']['TA']}}
                                                            </th>
                                                            <!--Win Loss(W/L)-->
                                                            <th class="tableCtnRight" style="top:0px; position:static;">
                                                                {{this.getLanguage['MEM']['CKMWL']}}
                                                            </th>
                                                            <!--Win/Loss Type-->
                                                            <th class="tableCtnLeft" style="top:0px; position:static;">
                                                                {{this.getLanguage['MEM']['WL']}}
                                                            </th>
                                                            <!--Bet Amount-->
                                                            <th class="tableCtnRight" style="top:0px; position:static;">{{this.getLanguage['BETRPT']['BA']}}</th>
                                                            <!--Last Played Time-->
                                                            <th style="top:0px; position:static;">{{this.getLanguage['BETRPT']['LPDT']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="arr_TransactionList.length == 0">
                                                            <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                        </tr>
                                                        <tr v-for="(data,index) in arr_TransactionList">
                                                            <td class="tableCtnNo">{{ index + 1 }}</td>
                                                            <td class="kema-eft tableCtnLeft">
                                                                <router-link :to="{ path:'/R/WINLV2', query:{ gpi: data.GPI, as: 't', i: obj_member.I, u: obj_member.U, sagi: '3-' + obj_member.AGI, subagi: obj_member.SAGI, df: formatDateTime(filterStartDate, 'YYYY-MM-DD HH:mm:ss', 'DD MMM YYYY HH:mm:ss') }}" target="_blank">
                                                                    <b>{{utilGetErrorLanguage('GP.' + data.PN)}}</b>
                                                                </router-link>
                                                            </td>
                                                            <td class="tableCtnLeft" v-if="getUserInfo.AT == 0">{{ data.PLI }}</td>
                                                            <td class="tableCtnRight">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                                                            <td :class="data.WLA >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(data.WLA, 2, data.CS) }}</td>
                                                            <td class="tableCtnLeft" :class="data.WLA>=0? 'positive-number':'negative-number'">{{ checkWL(data.WLA) }}</td>
                                                            <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.CS) }}</td>
                                                            <td class="tableCtnLeft">{{ formatDateTime(data.LUTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                        </tr>
                                                        <tr align="center" v-if="bool_showMoreTransactionBtn">
                                                            <td colspan="7" @click="showMoreTransaction()"><span style="color:darkblue;font-weight:bold;font-size:15px;cursor:pointer;">{{this.getLanguage['HEA']['VM']}}</span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class='mb-3'>
                                            <header class="table-header">
                                                <strong>{{this.getLanguage['BETRPT']['BL']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                        <th>
                                                            {{this.getLanguage['MEM']['CKMPVD']}}
                                                        </th>
                                                        <th class="tableCtnRight">
                                                            {{this.getLanguage['BETRPT']['BA']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_PendingTransactionList.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_PendingTransactionList">
                                                        <td class="tableCtnNo">{{ index + 1 }}</td>
                                                        <td class="kema-eft">
                                                            <router-link :to="{ path:'/R/BTL', query:{ gpi: data.GPI, agi: data.AGI, i: obj_member.I, u: obj_member.U, df: parseDateToJsonString(data.CTS) }}" target="_blank">
                                                                <b>{{utilGetErrorLanguage('GP.' + data.PN)}}</b>
                                                            </router-link>
                                                        </td>
                                                        <td :class="data.BA >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(data.BA, 2, data.ISOC, false) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--transaction-->
                        <CCollapse :show="Transcollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div>
                                        <div class='m-0'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['MEM']['L20T']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th>
                                                            {{this.getLanguage['QRC']['T']}}
                                                        </th>
                                                        <th>
                                                            {{this.getLanguage['MTA']['ABD']}}
                                                        </th>
                                                        <th class="tableCtnRight">
                                                            {{this.getLanguage['TD']['A']}}
                                                        </th>
                                                        <th>
                                                            {{this.getLanguage['GL']['DT']}}
                                                        </th>
                                                        <th>
                                                            {{this.getLanguage['MEM']['CKMS']}}
                                                        </th>
                                                        <th>
                                                            {{this.getLanguage['LOGRPT']['OP']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_Last5TransactionReportList.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_Last5TransactionReportList">
                                                        <td>{{ index + 1 }}</td>
                                                        <td :style="changeColor(data.AC)">
                                                            <span v-if="checkModuleAccess('DR2', 'R', constAccessType.view) && data.TT == 1">
                                                                <router-link :to="{ path:'/R/DR2', query:{ agi: '3-' + data.AGI, mi: data.MI, u: obj_member.U, rs: data.RS, df: parseDateToJsonString(data.DT), dt: parseDateToJsonString(data.DT).slice(0,-3)+'997' }}" target="_blank" :style="changeColor(data.AC)">
                                                                    {{data.T}}
                                                                </router-link>
                                                            </span>
                                                            <span v-else-if="checkModuleAccess('DR2', 'R', constAccessType.view) && data.TT == 2">
                                                                <router-link :to="{ path:'/R/WR2', query:{ agi: '3-' + data.AGI, mi: data.MI, u: obj_member.U, rs: data.RS, df: parseDateToJsonString(data.DT), dt: parseDateToJsonString(data.DT).slice(0,-3)+'997' }}" target="_blank" :style="changeColor(data.AC)">
                                                                    {{data.T}}
                                                                </router-link>
                                                            </span>
                                                            <span v-else>
                                                                {{data.T}}
                                                            </span>
                                                        </td>
                                                        <td v-if="data.TT == 1">
                                                            <span v-if="(data.BN != '' || data.BA != '' || data.BAN != '') && data.PM !=7">
                                                                <span class="grid-line">{{ data.BN }}</span>
                                                                <span class="grid-line">{{ data.BA }}</span>
                                                                <span class="grid-line">{{ data.BAN }}</span>
                                                            </span>
                                                            <span v-else-if="data.PM==7">
                                                                <span class="grid-line">{{ data.MB }}</span>
                                                                <span class="grid-line">{{ data.MBN }}</span>
                                                            </span>
                                                            <span v-else-if="data.PM==30">{{getLanguage['MTA']['CCARD']}}</span>
                                                            <span v-else-if="data.PM==13 || data.PM==26">{{getLanguage['ACO']['TUP']}}</span>
                                                            <span v-else-if="data.PM==20 || data.PM==27 || data.PM==28 || data.PM==44">{{getLanguage['ACO']['SUREP']}}</span>
                                                            <span v-else-if="data.PM==32">{{getLanguage['MTA']['TMONEY']}}</span>
                                                            <span v-else-if="data.PM==39">{{getLanguage['ACO']['LP']}}</span>
                                                            <span v-else-if="data.PM==43">{{getLanguage['ACO']['BCP']}}</span>
                                                            <span v-else-if="data.PM==45">{{getLanguage['ACO']['SMP']}}</span>
                                                            <span v-else-if="data.PM==45">{{getLanguage['ACO']['FPG']}}</span>
                                                            <span v-else-if="data.PM==45">{{getLanguage['ACO']['PGA']}}</span>
                                                            <span v-else-if="data.PM==49">{{getLanguage['ACO']['PP']}}</span>
                                                            <span v-else-if="data.PM==51">{{getLanguage['ACO']['DN']}}</span>
                                                            <span v-else-if="data.PM==52">{{getLanguage['ACO']['AGP']}}</span>
                                                            <span v-else-if="data.PM==55">{{getLanguage['ACO']['UP']}}</span>
                                                            <span v-else-if="data.PM==56 || data.PM == 58 || data.PM == 59">{{getLanguage['ACO']['OKP']}}</span>
                                                            <!--<span v-else-if="data.PM==57">{{getLanguage['ACO']['MGP']}}</span>-->
                                                            <span v-else-if="data.PM==60">{{getLanguage['ACO']['VIP']}}</span>
                                                            <span v-else-if="data.PM==61">{{getLanguage['ACO']['AFP']}}</span>
                                                            <span v-else-if="data.PM==63">{{getLanguage['ACO']['ONEP']}}</span>
                                                            <span v-else-if="data.PM==64">{{getLanguage['ACO']['BLEUP']}}</span>
                                                            <span v-else-if="data.PM==65">{{getLanguage['MTA']['DPM65']}}</span>
                                                            <span v-else-if="data.PM==62">{{getLanguage['ACO']['E88P']}}</span>
                                                            <span v-else-if="data.PM==67">{{getLanguage['ACO']['ECP']}}</span>
                                                            <span v-else-if="data.PM==68">{{getLanguage['ACO']['DGPCNY']}}</span>
                                                            <span v-else-if="data.PM==69">{{getLanguage['ACO']['SUPER7VND']}}</span>
                                                            <span v-else-if="data.PM==70 || data.PM==71 || data.PM==72 || data.PM==73 || data.PM==74">{{getLanguage['ACO']['ZPAY']}}</span>
                                                            <span v-else-if="data.PM==75">{{getLanguage['ACO']['UPAY']}}</span>
                                                            <span v-else-if="data.PM==77 || data.PM==78 || data.PM==79 || data.PM==80 || data.PM==81 || data.PM==82 || data.PM==83 || data.PM==84 || data.PM==85">{{getLanguage['ACO']['PAYPRO']}}</span>
                                                            <span v-else-if="data.PM==86">{{getLanguage['ACO']['PAYLITE']}}</span>
                                                            <span v-else-if="data.PM==87">{{getLanguage['ACO']['HUIJUCAI']}}</span>
                                                            <span v-else-if="data.PM==88">{{getLanguage['ACO']['BestPay']}}</span>
                                                            <span v-else-if="data.PM==89">{{getLanguage['ACO']['CLOUDPAY']}}</span>
                                                            <span v-else-if="data.PM==90 || data.PM==91">{{getLanguage['ACO']['LNWPAY']}}</span>
                                                            <span v-else>-</span>
                                                        </td>
                                                        <td v-else-if="data.TT == 2">
                                                            <span v-if="data.PM==8">{{getLanguage['ACO']['OP']}}</span>
                                                            <span v-if="data.PM==9">{{getLanguage['ACO']['OP']}}</span>
                                                            <span v-if="data.PM==23">{{getLanguage['ACO']['OP']}}</span>
                                                            <span v-if="data.PM==24">{{getLanguage['ACO']['OP']}}</span>
                                                            <span v-if="data.PM==13">{{getLanguage['ACO']['TUP']}}</span>
                                                            <span v-if="data.PM==26">{{getLanguage['ACO']['TUP']}}</span>
                                                            <span v-if="data.PM==39">{{getLanguage['ACO']['LP']}}</span>
                                                            <span v-if="data.PM==43">{{getLanguage['ACO']['BCP']}}</span>
                                                            <span v-if="data.PM==44 || data.PM==20 || data.PM==27">{{getLanguage['ACO']['SUREP']}}</span>
                                                            <span v-if="data.PM==12 || data.PM==14 || data.PM==15 || data.PM==16 || data.PM==29">{{getLanguage['ACO']['EZP']}}</span>
                                                            <span v-if="data.PM==33">{{getLanguage['ACO']['SMP']}}</span>
                                                            <span v-if="data.PM==45">{{getLanguage['ACO']['SMPIDR']}}</span>
                                                            <span v-if="data.PM==46">{{getLanguage['ACO']['FPG']}}</span>
                                                            <span v-if="data.PM==47">{{getLanguage['ACO']['PGA']}}</span>
                                                            <span v-if="data.PM==49">{{getLanguage['ACO']['PP']}}</span>
                                                            <span v-if="data.PM==51">{{getLanguage['ACO']['DN']}}</span>
                                                            <span v-if="data.PM==53">{{getLanguage['ACO']['P918']}}</span>
                                                            <span v-if="data.PM==55">{{getLanguage['ACO']['UP']}}</span>
                                                            <span v-if="data.PM==56 || data.PM==58 || data.PM==59">{{getLanguage['ACO']['OKP']}}</span>
                                                            <!--<span v-if="data.PM==57">{{getLanguage['ACO']['MGP']}}</span>-->
                                                            <span v-if="data.PM==61">{{getLanguage['ACO']['AFP']}}</span>
                                                            <span v-if="data.PM==62">{{getLanguage['ACO']['E88P']}}</span>
                                                            <span v-if="data.PM==63">{{getLanguage['ACO']['ONEP']}}</span>
                                                            <span v-if="data.PM==64">{{getLanguage['ACO']['BLEUP']}}</span>
                                                            <!--<span v-if="data.PM==66">{{getLanguage['ACO']['PPYP']}}</span>-->
                                                            <span v-if="data.PM==67">{{getLanguage['ACO']['ECP']}}</span>
                                                            <span v-if="data.PM==68">{{getLanguage['ACO']['DGPCNY']}}</span>
                                                            <span v-if="data.PM==69">{{getLanguage['ACO']['SUPER7VND']}}</span>
                                                            <span v-if="data.PM==70 || data.PM==71 || data.PM==72 || data.PM==73 || data.PM==74">{{getLanguage['ACO']['ZPAY']}}</span>
                                                            <span v-if="data.PM==75">{{getLanguage['ACO']['UPAY']}}</span>
                                                            <!--<span v-if="data.PM==76">{{getLanguage['ACO']['PAYNGO']}}</span>-->
                                                            <span v-if="data.PM==77 || data.PM==78 || data.PM==79 || data.PM==80 || data.PM==81 || data.PM==82 || data.PM==83 || data.PM==84 || data.PM==85">{{getLanguage['ACO']['PAYPRO']}}</span>
                                                            <span v-if="data.PM==86">{{getLanguage['ACO']['PAYLITE']}}</span>
                                                            <span v-if="data.PM==87">{{getLanguage['ACO']['HUIJUCAI']}}</span>
                                                            <span v-if="data.PM==88">{{getLanguage['ACO']['BestPay']}}</span>
                                                            <span v-if="data.PM==89">{{getLanguage['ACO']['CLOUDPAY']}}</span>
                                                            <span v-if="data.PM==90 || data.PM==91">{{getLanguage['ACO']['LNWPAY']}}</span>
                                                            <span v-if="data.BankList != null && data.BankList.length > 0">
                                                                <span v-for="bank in data.BankList">
                                                                    <span class="grid-line">{{ bank.BN }}</span>
                                                                    <span class="grid-line">{{ HideInfo(getUserInfo.IHMI, bank.BA, 4) }}</span>
                                                                    <span class="grid-line">{{ HideInfo(getUserInfo.IHMI, bank.BAN, 4) }}</span>
                                                                </span>
                                                            </span>
                                                            <span v-else-if="data.TM == 0 && data.PM == 0 || data.TM == 0 && data.PM == 1">{{getLanguage['MWB']['NFBD']}}</span>
                                                            <span v-else-if="data.PM==65">{{getLanguage['MTA']['WPM65']}}</span>
                                                            <span v-else>-</span>
                                                        </td>
                                                        <td v-else>-</td>                                                     
                                                        <td class="tableCtnRight" :style="changeColor(data.TA == 0 ? data.RSC : data.AC)">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                                                        <td>{{data.DT}}</td>
                                                        <td :style="changeColor(data.RSC)">{{data.S}}</td>
                                                        <td>{{data.UB}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--member's Log-->
                        <CCollapse :show="logcollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div>
                                        <div class='m-0'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['LOGRPT']['MLOG']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                        <th class="tableCtnLeft" style="top:0px">
                                                            {{ this.getLanguage['LOGRPT']['LT'] }}
                                                        </th>

                                                        <th class="tableCtnLeft" style="top:0px">
                                                            {{ this.getLanguage['LOGRPT']['ACT'] }}

                                                        </th>

                                                        <th class="tableCtnRight" style="top:0px">
                                                            {{this.getLanguage['MEM']['A']}}
                                                        </th>
                                                        <th class="tableCtnLeft" style="top:0px">
                                                            {{ this.getLanguage['GL']['IP'] }}

                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_memberlog.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_memberlog" :key="data.ID">
                                                        <td class="tableCtnNo">{{ index + 1 }}</td>
                                                        <td class="tableCtnLeft">{{ formatDateTime(data.LTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                        <td class="tableCtnLeft">
                                                            <span v-if="data.LA != 'ApplyDeposit' && data.LA != 'ApplyWithdrawal'">{{ renderAction(data.LA) }}</span>
                                                            <span v-else-if="data.LA == 'ApplyDeposit'" style="color:green">{{ data.LA }}</span>
                                                            <span v-else-if="data.LA == 'ApplyWithdrawal'" style="color:red">{{ data.LA }}</span>
                                                            <span v-if="data.GP != 'NONE' && data.GC == 'NONE' && data.GMEC == 'NONE'">&nbsp;"{{ renderProviderName(data.GP) }}"</span>
                                                            <span v-if="data.GC != 'NONE' && data.GP == 'NONE' && data.GMEC == 'NONE'">&nbsp;"{{ (data.GC) }}"</span>
                                                            <span v-if="data.GMEC != 'NONE'">&nbsp;"{{ renderProviderName(data.GP) }} - {{ renderGameName(data.GP, data.GMEC) }}"</span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span v-if="data.TA == 0">-</span>
                                                            <span v-else-if="data.LA == 'ApplyDeposit'" style="color:green">{{ formatNumber(data.TA, 2, data.CS) }}</span>
                                                            <span v-else-if="data.LA == 'ApplyWithdrawal'" style="color:red">{{ formatNumber(data.TA, 2, data.CS) }}</span>
                                                            <span v-else>{{ formatNumber(data.TA, 2, data.CS) }}</span>
                                                        </td>
                                                        <td class="tableCtnLeft">{{data.IPA}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--Affiliate-->
                        <CCollapse :show="Affiliatecollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div>
                                        <div class='m-0'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['SMB']['AFF']}}</strong>
                                                <div v-if="int_IMT == 1" class="ml-2">
                                                    <CButton color="primary" size="sm" class="mb-2" :class="int_ActiveLVL == 0 ? 'active' : ''" @click="getmemberAffiliate(0)">
                                                        {{this.getLanguage["GL"]["ALL2"]}}
                                                    </CButton>
                                                    <CButton v-if="int_LVL1 == 1" color="primary" size="sm" class="mb-2" :class="int_ActiveLVL == 1 ? 'active' : ''" @click="getmemberAffiliate(1,1)">
                                                        {{this.getLanguage["AFF"]["T"]}} 1
                                                    </CButton>
                                                    <CButton v-if="int_LVL2 == 2" color="primary" size="sm" class="mb-2" :class="int_ActiveLVL == 2 ? 'active' : ''" @click="getmemberAffiliate(2,1)">
                                                        {{this.getLanguage["AFF"]["T"]}} 2
                                                    </CButton>
                                                    <CButton v-if="int_LVL3 == 3" color="primary" size="sm" class="mb-2" :class="int_ActiveLVL == 3 ? 'active' : ''" @click="getmemberAffiliate(3,1)">
                                                        {{this.getLanguage["AFF"]["T"]}} 3
                                                    </CButton>
                                                    <CButton v-if="int_LVL4 == 4" color="primary" size="sm" class="mb-2" :class="int_ActiveLVL == 4 ? 'active' : ''" @click="getmemberAffiliate(4,1)">
                                                        {{this.getLanguage["AFF"]["T"]}} 4
                                                    </CButton>
                                                </div>
                                                <div class="pageBtn">
                                                    <button @click="ctrPageAff(+int_Page_Aff - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page_Aff"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPageAff(+int_Page_Aff,0)" />
                                                    <span class="tableItemCount">/ {{int_TP_Aff}}</span>
                                                    <button @click="ctrPageAff(+int_Page_Aff + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th style="width:20px">{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th style="width:50px">{{this.getLanguage["GL"]["S"]}}</th>
                                                        <th v-if="int_IMT == 1" style="width:50px">{{this.getLanguage["AFF"]["T"]}}</th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['U']}}

                                                        </th>

                                                        <th class="tableCtnRight" style="top:0px">
                                                            {{this.getLanguage['MEM']['MTDTOA_MW']}}
                                                            <i @click="setSortTable('MTDTOA')" :class="setSortLogo('MTDTOA')" class="sortlogo"></i>
                                                        </th>

                                                        <th class="tableCtnRight" style="top:0px">
                                                            {{this.getLanguage['MEM']['MTDWLA_MW']}}
                                                            <i @click="setSortTable('MTDWLA')" :class="setSortLogo('MTDWLA')" class="sortlogo"></i>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_affiliate.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_affiliate" :class="data.AS == 1? 'blacklist-row': ''">
                                                        <td>{{ CountItemAff(index+1) }}</td>
                                                        <td style="text-align:center">
                                                            <label class="switch">
                                                                <input type="checkbox" true-value="2" false-value="1" v-model="data.AS" @click="updateAffStatus(data)" :disabled="!checkModuleAccess('ML', 'M', constAccessType.edit)">
                                                                <span class="slider round" :style="disabledPointer()"></span>
                                                            </label>
                                                        </td>
                                                        <td v-if="int_IMT == 1">{{ data.LVL }}</td>
                                                        <td>
                                                            <span class="grid-line">
                                                                {{data.U}}
                                                                <div class="custom_tooltip" v-if="data.TW == 0">
                                                                    <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                                </div>

                                                            </span>
                                                            <span v-if="int_IMT == 1" class="saggroupname">{{ data.RN }}</span>
                                                            <span v-if="data.AS==1" class="grid-line rejectReason">{{renderDisqualifyReason(data.DAR)}}</span>
                                                        </td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.MTDTOA, 2, data.CS) }}</td>
                                                        <td :class="'tableCtnRight ' + (data.MTDWLA > 0 ? 'text-green-2' : (data.MTDWLA < 0 ? 'text-red1' : 'text-black'))">{{ formatNumber(data.MTDWLA, 2, data.CS) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--profile-->
                        <CCollapse :show="Profilecollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive" style="min-height:320px">
                                    <div v-if="!HideContactInfo">
                                        <div class='mb-3'>
                                            <header class="table-header" style="top:0px">
                                                <strong> {{this.getLanguage['MEM']['CKMB']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['E']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['PN']}}
                                                        </th>

                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['WC']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['LID']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['WAID']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['TGID']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['ZLID']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_memberContact.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_memberContact">
                                                        <td>
                                                            <span v-if="data.E == ''">-</span>
                                                            <span v-else>{{ HideInfo(HideContactInfo, data.E, 4) }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.PN == ''">-</span>
                                                            <span v-else>{{ HideInfo(HideContactInfo, data.PN, 4) }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.WC == ''">-</span>
                                                            <span v-else>{{ HideInfo(HideContactInfo, data.WC, 4) }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.LID == ''">-</span>
                                                            <span v-else>{{ HideInfo(HideContactInfo, data.LID, 4) }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.WAID == ''">-</span>
                                                            <span v-else>{{ HideInfo(HideContactInfo, data.WAID, 4) }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.TGID == ''">-</span>
                                                            <span v-else>{{ HideInfo(HideContactInfo, data.TGID, 4) }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.ZLID == ''">-</span>
                                                            <span v-else>{{ HideInfo(HideContactInfo, data.ZLID, 4) }}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div>
                                        <div class='mb-3'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['SMB']['BL']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['BI']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['BA']}}
                                                        </th>

                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['BAN']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['CAW']['QRC']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_memberBank.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_memberBank" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row' : data.RS == 4 ? 'warninglist-row' : data.IB? 'highrisk-row':''">
                                                        <td class="tableCtnNo">{{ index + 1 }}</td>
                                                        <td>
                                                            <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                <span>{{data.BN}} ({{data.BC}})</span>
                                                                <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                            </div>
                                                            <div v-else>
                                                                {{data.BN}} ({{data.BC}})
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                <span>{{ HideInfo(HideBankInfo, data.BA, 4) }}</span>
                                                                <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                            </div>
                                                            <div v-else>
                                                                {{ HideInfo(HideBankInfo, data.BA, 4) }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                <span>{{ HideInfo(HideBankInfo, data.BAN, 4) }}</span>
                                                                <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                            </div>
                                                            <div v-else>
                                                                {{ HideInfo(HideBankInfo, data.BAN, 4) }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <a v-if="data.QRCImage || data.QRCURL" href="javascript:void(0)" style="color:blue" @click="setPreview(data.QRCImage, data.QRCURL)">
                                                                <u>{{getLanguage["GL"]["P"]}}</u>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div>
                                        <div class='mb-3'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['MEM']['CL']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['CAL']['CN']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['CAL']['AN']}}
                                                        </th>

                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['CWA']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_memberCrypto.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_memberCrypto" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row' : data.IB? 'highrisk-row':''">
                                                        <td class="tableCtnNo">{{ index + 1 }}</td>
                                                        <td>
                                                            <div>
                                                                {{data.CN}}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ HideInfo(HideBankInfo, data.CA, 4) }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ HideInfo(HideBankInfo, data.CAD, 4) }}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--pokerV-->
                        <CCollapse :show="PokerVcollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div>
                                        <div class='m-0'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['MEM']['L20PVT']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['AG']['GP']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['QRC']['T']}}
                                                        </th>
                                                        <th class="tableCtnRight" style="top:0px">
                                                            {{this.getLanguage['TD']['A']}}
                                                        </th>

                                                        <th style="top:0px">
                                                            {{this.getLanguage['GL']['DT']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MEM']['CKMS']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_Last5PokerVTransactionReportList.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_Last5PokerVTransactionReportList">
                                                        <td>{{data.GPN}}</td>
                                                        <td :style="changeColor(data.AC)">
                                                            {{data.T}}
                                                        </td>
                                                        <td class="tableCtnRight" :style="changeColor(data.AC)">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                                                        <td>{{data.CTS}}</td>
                                                        <td :style="changeColor(2)">{{data.Status}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--Crypto wallet list-->
                        <CCollapse :show="CryptoWalletcollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div>
                                        <div class='m-0'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['MEM']['CWL']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th style="top:0px">{{this.getLanguage['MEM']['CWN']}}</th>
                                                        <th style="top:0px">{{this.getLanguage['MEM']['CWCB']}}</th>
                                                        <th style="top:0px">{{this.getLanguage['MEM']['CWTD']}}</th>
                                                        <th style="top:0px">{{this.getLanguage['MEM']['CWTW']}}</th>
                                                        <th style="top:0px">{{this.getLanguage['MEM']['CWTO']}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="!obj_member.MCW || obj_member.MCW.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-if="obj_member.MCW" v-for="(data, index) in obj_member.MCW">
                                                        <td>{{data.CN[0].toUpperCase() + data.CN.slice(1)}}</td>
                                                        <td>{{formatNumber(data.CBL, 2, data.CS)}}</td>
                                                        <td>{{formatNumber(data.TD, 2, data.CS)}}</td>
                                                        <td>{{formatNumber(data.TW, 2, data.CS)}}</td>
                                                        <td>{{formatNumber(data.TO, 2, data.CS)}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>

                        <!--PromoPayout transaction-->
                        <CCollapse :show="PromoPayoutcollapse">
                            <CCard body-wrapper>
                                <div class="table-responsive">
                                    <div>
                                        <div class='m-0'>
                                            <header class="table-header" style="top:0px">
                                                <strong>{{this.getLanguage['MEM']['LPPPT']}}</strong>
                                            </header>
                                            <table class='custom-table custom-tableMP afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th class="tableCtnNo">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['AG']['GP']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['MTA']['TID']}}
                                                        </th>
                                                        <th class="tableCtnRight" style="top:0px">
                                                            {{this.getLanguage['TD']['A']}}
                                                        </th>
                                                        <th style="top:0px">
                                                            {{this.getLanguage['GL']['DT']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_PromoPayoutTransactionReportList.length == 0">
                                                        <td colspan="100%" class="text-center">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_PromoPayoutTransactionReportList">
                                                        <td class="tableCtnNo">{{ index + 1 }}</td>
                                                        <td>{{ renderProviderName(data.GPN)}}</td>
                                                        <td>
                                                            {{data.TI}}
                                                        </td>
                                                        <td class="tableCtnRight" :style="changeColor(data.AC)">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                                                        <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                        </CCollapse>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constAccessType, constRejectReasonBL, constRejectReasonF, constTranType, consDeviceType, loadingFullScreen, constDisqualifyMemberAff } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import { mapGetters } from 'vuex';
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { required, email, sameAs, requiredIf, alphaNum, decimal, minValue } from 'vuelidate/lib/validators'
    import Vue from 'vue'
    import $ from 'jquery'
    import MemberCombineModal from "../MemberCombineModal";

    export default {
        mixins: [genericHelper],
        components: {
            Loading,
            Treeselect,
            DateRangePicker,
            MemberCombineModal
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),            
        },
        data() {
            return {
                id: null,
                agi: null,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_EnableAffiliate: false,
                bool_haveRef: false,
                bool_cacheOptionValue: false,
                int_RC: 5, //Row Count
                int_RC_Pending: 10,
                int_RC_Aff: 100,
                // for transaction list
                int_Total: 0,
                int_Total_Aff: 0,
                int_Page: 1,
                int_Page_Aff: 1,
                str_tableSortBy_Aff: "U", //(sort the table col name)
                bool_isSort_Aff: true, // Table Ascending Descending
                int_TP: 0, //Total Page
                int_TP_Aff: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                // for pending transaction list
                int_Page_Pending: 1,
                str_tableSortBy_Pending: "", //(sort the table col name)
                bool_isSort_Pending: true, // Table Ascending Descending
                bool_formCollapsed: false,
                arr_TransactionList: [],
                arr_PendingTransactionList: [],
                arr_PromotionList: [],
                arr_memberWallet: [],
                obj_member: {},
                filterStartDate: moment(this.getTodayDate()).format("YYYY-MM-DD HH:mm:ss"),
                //obj_memberRanking: {},
                dec_allBalance: 0.0000,
                bool_showAllTransaction: false,
                bool_showAllPendingTransaction: false,
                bool_showAllPromotion: false,
                bool_showMorePendingTransactionBtn: false,
                bool_showMoreTransactionBtn: false,
                arr_PromotionReportList: [],
                arr_PromotionHistoryReportList: [],
                arr_AutoRebateReportList: [],
                arr_TotalAutoRebate: [],
                arr_Last5TransactionReportList: [],
                arr_Last5PokerVTransactionReportList: [],
                arr_PromoPayoutTransactionReportList: [],
                arr_memberlog: [],
                arr_memberContact: [],
                arr_memberBank: [],
                arr_memberCrypto: [],
                arr_affiliate: [],
                arr_DLSReportList: [],
                obj_trans: [],
                bool_ARD: false, // auto rebate details
                bool_DLSD: false, // dls details
                bool_isDeposit: false,
                Promocollapse: false,
                Gamecollapse: false,
                Transcollapse: false,
                Profilecollapse: false,
                Affiliatecollapse: false,
                PokerVcollapse: false,
                PromoPayoutcollapse: false,
                logcollapse: false,
                CryptoWalletcollapse: false,
                constAccessType: constAccessType,
                showPokerVWalletArea: false,
                bool_isDisqualifyAff: false,
           
                obj_memberAFF: {},
                int_TP_AR: 1,
                int_Page_AR: 1,
                int_RC_AR: 100,
                int_IC_AR: 1,
                int_IC_Aff: 1,
                _loyaltyData: null,

                editMemberInfo: null,
                editMemberBlock: null,
                editMemberFreeze: null,
                editMemberGame: null,

                //action button
                bool_isAMV: false,
                editBirthday: { startDate: null, endDate: null },
                bool_barCV: false,
                IsMember: 0,
                dummyInt: 0,
     
                bool_isBAR: false,
                HideContactInfo: false,
                HideBankInfo: false,
                EditBankInfo: false,
                ddMarketerList: [],
                ddDefaultMarketerList: null,
                regexDecimal: new RegExp("^[0-9]+[\.]?[0-9]*$"),
                rtAffiliateKey: 0,

                //megaGaming
                CurrentGPI: 0,
                showMegaGamingWalletArea: false,
                showMegaV3GamingWalletArea: false,
                bool_isMegaGamingTransfer: false,
                megaGamingDepositAmount: 0,
                megaGamingWithdrawAmount: 0,
                megaGamingTransferObj: {
                    "I": 0,
                    "AGI": 0,
                    "CI": 0,
                    "transferType": 0,
                    "amount": 0,
                    "GPI": 0
                },

                //pussy888
                showPussy888WalletArea: false,
                bool_isPussy888Transfer: false,
                Pussy888DepositAmount: 0,
                Pussy888WithdrawAmount: 0,
                Pussy888TransferObj: {
                    "I": 0,
                    "AGI": 0,
                    "CI": 0,
                    "U": "",
                    "transferType": 0,
                    "amount": 0
                },

                //Kiss918
                showKiss918WalletArea: false,
                bool_isKiss918Transfer: false,
                Kiss918DepositAmount: 0,
                Kiss918WithdrawAmount: 0,
                Kiss918TransferObj: {
                    "I": 0,
                    "AGI": 0,
                    "CI": 0,
                    "U": "",
                    "transferType": 0,
                    "amount": 0
                },

                //IG_GFC
                showIG_GFCWalletArea: false,
                bool_isIG_GFCTransfer: false,
                IG_GFCDepositAmount: 0,
                IG_GFCWithdrawAmount: 0,
                IG_GFCTransferObj: {
                    "I": 0,
                    "AGI": 0,
                    "amount": 0
                },

                //IG_LOTTERY
                showIG_LOTTERYWalletArea: false,
                bool_isIG_LOTTERYTransfer: false,
                IG_LOTTERYDepositAmount: 0,
                IG_LOTTERYWithdrawAmount: 0,
                IG_LOTTERYTransferObj: {
                    "I": 0,
                    "AGI": 0,
                    "amount": 0
                },

                //IG_LOTTO
                showIG_LOTTOWalletArea: false,
                bool_isIG_LOTTOTransfer: false,
                IG_LOTTODepositAmount: 0,
                IG_LOTTOWithdrawAmount: 0,
                IG_LOTTOTransferObj: {
                    "I": 0,
                    "AGI": 0,
                    "amount": 0
                },

                //DG3D_FISHING
                //showDG3D_FISHINGWalletArea: false,
                //bool_isDG3D_FISHINGTransfer: false,
                //DG3D_FISHINGDepositAmount: 0,
                //DG3D_FISHINGWithdrawAmount: 0,
                //DG3D_FISHINGTransferObj: {
                //    "I": 0,
                //    "AGI": 0,
                //    "amount": 0
                //},

                //WICKET9
                showWICKET9WalletArea: false,
                bool_isWICKET9Transfer: false,
                WICKET9DepositAmount: 0,
                WICKET9WithdrawAmount: 0,
                WICKET9TransferObj: {
                    "I": 0,
                    "AGI": 0,
                    "CI": 0,
                    "U": "",
                    "transferType": 0,
                    "amount": 0
                },

                bool_FSD: false, // free spin details
                selectedQRCode: null,
                previewUrl: null,
                bool_fullPreview: false,
                int_IMT: 0,
                int_LVL1: 0,
                int_LVL2: 0,
                int_LVL3: 0,
                int_LVL4: 0,
                int_ActiveLVL: 0,
                searchAgi: null,
                showFilterGT: null,
                showPrevFilterGT: null,
                DateTime: this.getTodayDate(),
                //defaultBadge: [],

                //Member Profile Promotion Type Status
                dlsIsDisabled: false,
                autoRIsDisabled: false,
                refIsDisabled: false,
                prizeDIsDisabled: false,

                int_TP_GBT: 1,
                int_Page_GBT: 1,
                int_RC_GBT: 50,
                int_IC_GBT: 1,
                gbtData: null,

                GH_Date: {                        
                    FV: {
                        startDate: this.getTodayDate(),
                        endDate: this.getTodayEndDate()
                    }
                },

                MCMI_V: false,
            }
        },
        methods: {
            checkModuleAccess3(type) {
                return this.checkModuleAccess('BLL', 'M', type);
            },
            renderLoginDetails(isMobile) {
                if (isMobile == 1) {
                    var details = "";
                    if (this.obj_member.LB.Browser != "unknown") {
                        details += this.obj_member.LB.Browser;
                    }
                    if (this.obj_member.LB.MobileDevice != "unknown") {
                        details += " " + this.obj_member.LB.MobileDevice;
                    }
                    else if (this.obj_member.LB.MobileDeviceManufacturer != "unknown") {
                        details += " " + this.obj_member.LB.MobileDeviceManufacturer;
                    }
                    return details;
                }
                else if (isMobile == 0) {
                    return this.obj_member.LB.Browser;
                }
            },
            close5() {
                this.bool_isDisqualifyAff = !this.bool_isDisqualifyAff;
                this.bool_rejectCV = false;
                this.getmemberAffiliate();

            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (this.obj_member.MRCURL && this.obj_member.MRIURL) {
                    bgColor = '#7975D9';
                    textColor = '#fff';
                }
                if (data) {
                    if (data.MTBC) {
                        bgColor = data.MTBC;
                    }

                    if (data.MTC) {
                        textColor = data.MTC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px', fontSize: '12px', bottom: '-25%', left: '125%', marginLeft: '0%'
                };
            },
            getData() {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/m/gmbc/${this.agi}/${this.id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {                            
                            that.obj_member = Object.assign({}, d.D);
                            that.obj_member.MCW = d.MCW;
                            that.obj_member.LB = JSON.parse(that.obj_member.LB);
                            that.obj_member.TOTLWTCS = (d.D.ICT ? "USD" : d.D.CS);
                            that.obj_member.CN = (that.obj_member.AGI.toString().padStart(4, '0') + that.obj_member.DI.toString().padStart(4, '0') + that.obj_member.I.toString().padStart(8, '0')).replace(/(\d{4})(?=\d)/g, '$1 ')
                            if (that.obj_member.PVW != -1)
                                that.showPokerVWalletArea = true;
                            if (that.obj_member.MGW != -1)
                                that.showMegaGamingWalletArea = true;
                            if (that.obj_member.MV3GW != -1)
                                that.showMegaV3GamingWalletArea = true;
                            if (that.obj_member.PW != -1)
                                that.showPussy888WalletArea = true;
                            if (that.obj_member.K918W != -1)
                                that.showKiss918WalletArea = true;
                            if (that.obj_member.IGGFCW != -1)
                                that.showIG_GFCWalletArea = true;
                            //if (that.obj_member.DG3D_FISHINGW != -1)
                            //    that.showDG3D_FISHINGWalletArea = true;
                            if (that.obj_member.WICKET9W != -1)
                                that.showWICKET9WalletArea = true;

                            //if (that.obj_member.IGLOTTERYW != -1)
                            //    that.showIG_LOTTERYWalletArea = true;
                            //if (that.obj_member.IGLOTTOW != -1)
                            //    that.showIG_LOTTOWalletArea = true;
                            //that.showPokerVWalletArea = true;

                            //if (that.obj_member.MRI && that.obj_member.MRI > 0) {
                            //    that.bool_fullLoading = true;
                            //    that.getDataApi(`/api/memrank/g/${that.obj_member.MRI}`,
                            //        function (d, s) {
                            //            that.bool_fullLoading = false;
                            //            if (s) {
                            //                that.setMT(d.D);
                            //            }
                            //        });
                            //}

                            for (var i = 0; i < that.obj_member.PromotionTypeList.length; i++) {
                                if (that.obj_member.PromotionTypeList[i].PT == 1) {
                                    that.dlsIsDisabled = that.obj_member.PromotionTypeList[i].IDA;
                                }
                                if (that.obj_member.PromotionTypeList[i].PT == 2) {
                                    that.autoRIsDisabled = that.obj_member.PromotionTypeList[i].IDA;
                                }
                                if (that.obj_member.PromotionTypeList[i].PT == 3) {
                                    that.refIsDisabled = that.obj_member.PromotionTypeList[i].IDA;
                                }
                                if (that.obj_member.PromotionTypeList[i].PT == 4) {
                                    that.prizeDIsDisabled = that.obj_member.PromotionTypeList[i].IDA;
                                }
                                if (that.obj_member.PromotionTypeList[i].PT == 5) {
                                    that.tournamentIsDisabled = that.obj_member.PromotionTypeList[i].IDA;
                                }
                            }
                        }                           
                                                                                                            
                    });               
            },
            getWalletData() {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/m/gmbcw/${this.agi}/${this.id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.arr_memberWallet = d.D;
                            that.dec_allBalance = 0;
                            if (that.arr_memberWallet && that.arr_memberWallet.length > 0) {
                                for (var i = 0; i < that.arr_memberWallet.length; i++) {
                                    that.dec_allBalance += that.arr_memberWallet[i].WB;
                                }
                            }
                        }
                    });
            },
            getTransactionData(value) {
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                path += "&f.AGI=" + this.agi;
                path += "&f.I=" + this.id;
                path += "&f.GPC=" + this.obj_member.GPC;
                path += "&f.UN=" + this.obj_member.U;                                
                
                if (value == 1) {
                    //If value = 1 then just show all time game transaction
                    this.showPrevFilterGT = value;
                    this.showFilterGT = value;
                    path += "&f.FSGT=" + this.showFilterGT;

                    this.GH_Date.FV.startDate = this.formatDateTime(this.obj_member.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss");
                    this.GH_Date.FV.endDate = this.getTodayEndDate();                   
                }                
                else if (value == 2) {
                    //If value = 2 then show game transaction based on selected date
                    this.showPrevFilterGT = value;
                    path += "&f.FSGT=" + this.showFilterGT;

                    if (this.GH_Date.FV.startDate != "") {                                                
                        var start_date = moment(this.GH_Date.FV.startDate).format("YYYY-MM-DD");
                        path += "&f.SD=" + start_date;
                    }
                    if (this.GH_Date.FV.endDate != "") {                        
                        var end_date = moment(this.GH_Date.FV.endDate).format("YYYY-MM-DD");                            
                        path += "&f.ED=" + end_date;
                    }                                        
                }                
                else {
                    this.showPrevFilterGT = value;
                    this.showFilterGT = value;
                    //If value null then show today game transaction
                    this.GH_Date.FV.startDate = this.getTodayDate();
                    this.GH_Date.FV.endDate = this.getTodayEndDate();                                       
                }

                this.filterStartDate = moment(this.GH_Date.FV.startDate).format("YYYY-MM-DD HH:mm:ss");

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                var that = this;
                this.bool_fullLoading = true;
                this.getDataApi(`/api/m/lgt?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_showAllTransaction = false;
                        that.bool_showMoreTransactionBtn = false;

                        if (s) {
                            that.int_TP = 1;
                            that.int_Total = d.D.length;
                            that.arr_TransactionList = d.D;

                            if (that.int_RC == 50) {
                                that.bool_showAllTransaction = that.int_Total > 50;
                            }
                            else if (that.int_Total > 5) {
                                that.bool_showMoreTransactionBtn = false;
                            }
                        }
                    });
            },
            selectDateRangePickerUpdateEvent(dt) {
                if (dt) {                    
                    this.showFilterGT = 2;
                    if (dt.startDate) {
                        dt.startDate.setHours(0, 0, 0, 0);
                    }

                    if (dt.endDate) {
                        dt.endDate.setHours(23, 59, 59, 59, 997);
                    }
                }
            },
            DateTimeChange(type, event) {
                this.showFilterGT = 2;
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.GH_Date.FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.GH_Date.FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.GH_Date.FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.GH_Date.FV.endDate = "";
                    }
                }
            },                                
            getTransactionPendingData() {
                var path = this.getListingParamQuery(this.int_Page_Pending, this.int_RC_Pending, this.str_tableSortBy_Pending, this.bool_isSort_Pending);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                path += "&f.AGI=" + this.agi;
                path += "&f.MID=" + this.id;

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                var that = this;
                this.bool_fullLoading = true;
                this.getDataApi(`/api/m/betlist?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_PendingTransactionList = d.D.Items;
                        }
                    });
            },
            checkWL(value) {
                if (value > 0) {
                    return this.getLanguage["DB"]["WIN"];
                }
                else {
                    return this.getLanguage["DB"]["LOSS"];
                }
            },
            checkStatus(value) {
                if (value == 2) {
                    return 'color:green';
                }
                else if (value == 3 || value == 5 || value == 6 || value == 8) {
                    return 'color:red';
                }
                else if (value == 4) {
                    return 'color:blue';
                }
            },
            getPromotionReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 10, "ATS", true);
                if (path) {
                    path += "&";
                }

                path += (
                    "f.MI=" + this.id +
                    "&f.PTS_from=" +
                    "&f.PTS_to=" +
                    "&f.RS_in=2" +
                    "&f.PC=" +
                    "&f.ATAGI=" +
                    "&f.OP="
                );

                this.getDataApi(`/api/mpromo/pap?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;                        

                        if (s) {                                                         
                            if (d.D.Items == null) {
                                that.arr_PromotionReportList = [];
                            } else {
                                that.arr_PromotionReportList = d.D.Items;
                            }
                        }
                    });
            },
            getPromotionHistoryReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 10, "ATS", true);

                if (path) {
                    path += "&";
                }

                path += (
                    "f.MI=" + this.id +
                    "&f.PTS_from=" +
                    "&f.PTS_to=" +
                    "&f.RS_in=4,5,6,7,8,9" +
                    "&f.PC=" +
                    "&f.ATAGI=" +
                    "&f.OP="
                );

                this.getDataApi(`/api/mpromo/pap?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.D.Items == null) {
                                that.arr_PromotionHistoryReportList = [];
                            } else {
                                that.arr_PromotionHistoryReportList = d.D.Items;
                            }
                        }
                    });
            },
            getAutoRebateReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 7, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += (
                    "f.MI=" + this.id +
                    "&f.PTS_from=" +
                    "&f.PTS_to="
                );

                this.getDataApi(`/api/mloyalty/lr?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.D.Items == null) {
                                that.arr_AutoRebateReportList = [];
                            } else {
                                that.arr_AutoRebateReportList = d.D.Items;                                
                            }
                        }
                    });
                //this.getDataApi(`/api/mloyalty/tar?${path}`,
                //    function (d, s) {
                //        that.bool_fullLoading = false;
                //        if (s) {
                //            if (d == null) {
                //                that.arr_TotalAutoRebate = [];
                //            } else {
                //                that.arr_TotalAutoRebate = d;
                //            }
                                                       
                //        }
                //    });
            },
            getLast5TransactionReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 100, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += (
                    "f.I=" + this.id
                );
                this.getDataApi(`/api/memtrans/gl5t?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_Last5TransactionReportList = d.D.Items;
                            for (let i = 0; i < that.arr_Last5TransactionReportList.length; i++) {
                                let item = that.arr_Last5TransactionReportList[i];
                                if (item.UB == "sys||auto-depo") {
                                    item.UB = `${that.getLanguage['GS']['SYSTEM']} | ${that.getLanguage['MTA']['DPM6']}`;
                                }
                                else if (item.UB.includes("mem||")) {
                                    let operator = item.UB.replace("mem||", "");
                                    item.UB = `${that.getLanguage['SMB']['M']} >> ${operator}`;
                                } else if (item.UB.includes("sys")) {
                                    item.UB = `${that.getLanguage['GS']['SYSTEM']} ${that.getLanguage['GL']['AGE']}`;
                                }
                            }
                        }
                    });
            },
            //pokerv
            getLast5PokerVTransactionReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 20, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += (
                    "f.I=" + this.id + "&f.AGI=" + this.agi
                );

                //debugger;
                this.getDataApi(`/api/mempointtrans/gl5t?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_Last5PokerVTransactionReportList = d.D.Items;
                        }
                    });
            },
            getPromoPayoutTransactionReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 100, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += (
                    "f.I=" + this.id + "&f.AGI=" + this.agi
                );

                this.getDataApi(`/api/mempointtrans/promopayout?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_PromoPayoutTransactionReportList = d.D.Items;                            
                        }
                    });
            },
            getmemberLogs() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 20, "LTS", true);

                var i = this.id;

                path += "&f[LBI]=" + this.id;
                path += "&f[AGI]=" + this.agi;

                this.getDataApi(`/api/logs/member?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_memberlog = d.D.Items;
                        }
                    });
            },
            getmemberContact() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 5, "CTS", true);

                var i = this.id;
                this.getDataApi(`/api/m/memberprofile/${i}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_memberContact = d;
                        }
                    });
            },
            getmemberBank() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 5, "CTS", true);

                var i = this.id;
                this.getDataApi(`/api/m/memberBank/${i}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_memberBank = d;
                        }
                    });
            },
            getmemberCrypto() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 5, "CTS", true);

                var i = this.id;
                this.getDataApi(`/api/m/memberCrypto/${i}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_memberCrypto = d;
                        }
                    });
            },

            getmemberAffiliate(value, page) {
                this.bool_fullLoading = true;
                this.LVL = value;
                var that = this;
                if (page == 1) {
                    this.int_Page_Aff = page;
                };
                var path = this.getListingParamQuery(this.int_Page_Aff, this.int_RC_Aff, this.str_tableSortBy_Aff, this.bool_isSort_Aff);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }
                path += "&f.I=" + this.id;
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                if (value == null) {
                    path += "&f.LVL=1";
                    this.int_ActiveLVL = 1;
                } else {
                    path += "&f.LVL=" + value;
                    this.int_ActiveLVL = value;
                }


                this.getDataApi(`/api/m/memberAffiliate?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.arr_affiliate = [];
                        that.int_IMT = 0;
                        that.int_LVL1 = 0;
                        that.int_LVL2 = 0;
                        that.int_LVL3 = 0;
                        that.int_LVL4 = 0;
                        if (s) {
                            if (d.S) {
                                that.int_TP_Aff = Math.max(d.D.TotalPages, 1);
                                that.int_Total_Aff = d.D.TotalItems;
                                that.arr_affiliate = d.D.Items;
                                that.int_IMT = d.D.Items[0].IMT;
                                that.int_LVL1 = d.D.Items[0].LVL1;
                                that.int_LVL2 = d.D.Items[0].LVL2;
                                that.int_LVL3 = d.D.Items[0].LVL3;
                                that.int_LVL4 = d.D.Items[0].LVL4;
                            }
                        }
                    });
            },
            getDLSReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 10, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += (
                    "f.MI=" + this.id +
                    "&f.PTS_from=" +
                    "&f.PTS_to="
                );

                this.getDataApi(`/api/dlspromo/lr?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            if (d.D.Items == null) {
                                that.arr_DLSReportList = [];
                            } else {
                                that.arr_DLSReportList = d.D.Items;
                            }
                        }
                    });
            },
            ShowCollapse(value) {

                switch (value) {
                    //if (value == 1) {
                    case 1:
                        this.Gamecollapse = false;
                        this.Transcollapse = false;
                        this.Promocollapse = false;
                        this.Affiliatecollapse = false;
                        this.PokerVcollapse = false;
                        this.logcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.Profilecollapse = !this.Profilecollapse;
                        this.PromoPayoutcollapse = false;

                        if (this.Profilecollapse) {
                            if (!this.HideContactInfo) {
                                this.getmemberContact();
                            }
                            this.getmemberBank();
                            this.getmemberCrypto();
                        }
                        break;
                    //}
                    case 2:
                        //else if (value == 2) {
                        this.Gamecollapse = false;
                        this.Transcollapse = false;
                        this.Profilecollapse = false;
                        this.Affiliatecollapse = false;
                        this.PokerVcollapse = false;
                        this.logcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.Promocollapse = !this.Promocollapse;
                        this.PromoPayoutcollapse = false;


                        if (this.Promocollapse) {
                            if (this.checkModuleAccess('PAP', 'P', constAccessType.view)) {
                                this.getPromotionReportList();
                                this.getPromotionHistoryReportList()
                            }
                            if (this.checkModuleAccess('LR', 'R', constAccessType.view)) {
                                this.getAutoRebateReportList();
                            }
                            if (this.checkModuleAccess('DLSR', 'R', constAccessType.view)) {
                                this.getDLSReportList();
                            }
                        }

                        break;
                    //}
                    case 3:
                        //else if (value == 3) {
                        this.Promocollapse = false;
                        this.Transcollapse = false;
                        this.Profilecollapse = false;
                        this.Affiliatecollapse = false;
                        this.PokerVcollapse = false;
                        this.logcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.Gamecollapse = !this.Gamecollapse;
                        this.PromoPayoutcollapse = false;

                        if (this.Gamecollapse) {
                            this.getTransactionData();
                            this.getTransactionPendingData();
                        }
                        break;
                    //}
                    case 4:
                        //else if (value == 4) {
                        this.Promocollapse = false;
                        this.Gamecollapse = false;
                        this.Profilecollapse = false;
                        this.Affiliatecollapse = false;
                        this.PokerVcollapse = false;
                        this.logcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.Transcollapse = !this.Transcollapse;
                        this.PromoPayoutcollapse = false;

                        if (this.Transcollapse) {
                            this.getLast5TransactionReportList();
                        }
                        break;
                    //}
                    case 5:
                        //else if (value == 5) {
                        this.Promocollapse = false;
                        this.Gamecollapse = false;
                        this.Profilecollapse = false;
                        this.Transcollapse = false;
                        this.logcollapse = false;
                        this.PokerVcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.Affiliatecollapse = !this.Affiliatecollapse;
                        this.PromoPayoutcollapse = false;

                        if (this.Affiliatecollapse) {
                            this.getmemberAffiliate();
                        }
                        break;
                    //}
                    case 6:
                        //else if (value == 6) {
                        this.Promocollapse = false;
                        this.Gamecollapse = false;
                        this.Profilecollapse = false;
                        this.Transcollapse = false;
                        this.Affiliatecollapse = false;
                        this.PokerVcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.logcollapse = !this.logcollapse;
                        this.PromoPayoutcollapse = false;

                        if (this.logcollapse) {
                            this.getmemberLogs();
                        }
                        break;
                    //}
                    case 7:
                        //else if (value == 7) {
                        this.Promocollapse = false;
                        this.Gamecollapse = false;
                        this.Profilecollapse = false;
                        this.Transcollapse = false;
                        this.Affiliatecollapse = false;
                        this.logcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.PokerVcollapse = !this.PokerVcollapse;
                        this.PromoPayoutcollapse = false;

                        if (this.PokerVcollapse) {
                            //pokerv
                            this.getLast5PokerVTransactionReportList();
                        }
                        break;
                    //}
                    case 8: {
                        this.Promocollapse = this.Gamecollapse = this.Profilecollapse = this.Transcollapse = this.Affiliatecollapse = this.logcollapse = this.PokerVcollapse = false;
                        this.CryptoWalletcollapse = true;
                        this.PromoPayoutcollapse = false;
                        break;
                    }
                    case 9:
                        this.Promocollapse = false;
                        this.Gamecollapse = false;
                        this.Profilecollapse = false;
                        this.Transcollapse = false;
                        this.Affiliatecollapse = false;
                        this.logcollapse = false;
                        this.CryptoWalletcollapse = false;
                        this.PokerVcollapse = false;
                        this.PromoPayoutcollapse = !this.PromoPayoutcollapse;

                        if (this.PromoPayoutcollapse) {
                            this.getPromoPayoutTransactionReportList();
                        }
                        break;
                }
            },
            changeColor(value) {
                switch (value) {
                    case (0):
                        return {
                            color: 'blue'
                        }
                        break;
                    case (1):
                        return {
                            color: 'red'
                        }
                        break;
                    case (2):
                        return {
                            color: 'green'
                        }
                        break;
                }
            },

            setSortTable(SV) { // for transaction list
                //this.int_Page = 1;
                // this.int_IC = 1;
                //this.str_tableSortBy = SV;
                // this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                // this.getTransactionData();
                //for affiliate list
                this.int_Page_Aff = 1;
                this.int_IC_Aff = 1;
                this.str_tableSortBy_Aff = SV;
                this.bool_isSort_Aff = !this.bool_isSort_Aff;
                this.getmemberAffiliate(this.int_ActiveLVL);

            },
            setSortLogo(str_TF) { // for transaction list
                //return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
                // for affiliate list
                return `cil-${this.str_tableSortBy_Aff == str_TF ? (this.bool_isSort_Aff ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo

            },
            prevPage() { // for transaction list
                if (this.int_Page > 1) {
                    this.int_Page--;
                }
            },
            nextPage() { // for transaction list
                if (this.int_Page < this.int_TP) {
                    this.int_Page++;
                }
            },
            checkIpAddress(ip) {
                if (ip) {
                    return `https://whatismyipaddress.com/ip/${ip}`;
                    //return `https://whatismyipaddress.com/ip/${ip}`;
                }
                else {
                    return '#';
                }
            },
            showMoreTransaction() {
                this.int_RC = 50;
                this.getTransactionData();
            },
            renderStatus(statusCode) {
                return this.getLanguage['PM']['AC' + statusCode];
            },
            renderRejectReason(rejectReason) {
                const found = constRejectReasonP.some(el => el.id === rejectReason);

                if (found) {
                    for (var d of constRejectReasonP) {
                        if (d.id == rejectReason) {
                            rejectReason = d.label;
                        }
                    }
                }

                return rejectReason;
            },
            viewARDetail(loyaltyData = null) {
                if (loyaltyData == null) {
                    loyaltyData = this._loyaltyData;
                } else {
                    this._loyaltyData = loyaltyData;
                }
                this.obj_trans = [];
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page_AR, this.int_RC_AR, "CTS", true);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }
                path += "&f.LI=" + loyaltyData.LI +
                    "&f.MI=" + loyaltyData.MI +
                    "&f.PTS_from=" + loyaltyData.SF +
                    "&f.PTS_to=" + loyaltyData.ET +
                    "&f.I=" + loyaltyData.I
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                this.getDataApi(`/api/mloyalty/lr/trans?${path}`,
                    function (d, s) {
                        //    that.bool_fullLoading = false;
                        if (s) {
                            if (loyaltyData.LG == 3) {
                                that.bool_isDeposit = true;
                            } else {
                                that.bool_isDeposit = false;
                            }
                            that.int_TP_AR = Math.max(d.D.TotalPages, 1);
                            that.obj_trans = d.D.Items;
                            that.bool_ARD = true;
                            that.bool_fullLoading = false;
                        }
                    });
            },
            viewDLSDetail(dlsData) {
                this.gbtData = dlsData;
                this.obj_trans = [];
                this.bool_fullLoading = true;

                var that = this;                
                var path = this.getListingParamQuery(this.int_Page_GBT, this.int_RC_GBT, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += ("f.D=" + dlsData.BC +
                    "&f.mi=" + dlsData.MI +
                    "&f.GPI=" + dlsData.GPI);

                this.getDataApi(`/api/dlspromo/lr/trans?${path}`,
                    function (data) {
                        that.int_TP_GBT = Math.max(data.D.TotalPages, 1);
                        that.obj_trans = data.D.Items;
                        that.bool_DLSD = true;
                        that.bool_fullLoading = false;
                    });

            },
            closeARD() {
                this.bool_ARD = !this.bool_ARD;
            },
            closeDLSD() {
                this.bool_DLSD = !this.bool_DLSD;
                this.gbtData = null;
                this.int_IC_GBT = 1;
                this.int_Page_GBT = 1;
                this.int_TP_GBT = 1;
            },
            renderGameName(providerName, gameName) {
                if (providerName in this.getLanguage && gameName in this.getLanguage[providerName])
                    return this.getLanguage[providerName][gameName];

                return gameName;
            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }

            },
            renderPaymentMethod(pm) {
                return this.getLanguage['MTA']['DPM' + pm];
            },
            updateAffStatus(data) {
                if (data.AS == 1)
                    this.RequalifyMemberAFF(data);
                else
                    this.DisqualifyMemberAFF(data);
            },
            DisqualifyMemberAFF(d) {
                this.bool_rejectCV = false;
                this.dd_rejectreason = [{
                    id: "1",
                    label: this.getLanguage['MEM']['SIMA']
                },
                {
                    id: "2",
                    label: this.getLanguage['MEM']['HCD']
                },
                {
                    id: "3",
                    label: this.getLanguage['MEM']['SAA']
                },
                {
                    id: "4",
                    label: this.getLanguage['MEM']['IM']
                },
                {
                    id: "999",
                    label: this.getLanguage['BETRPT']['OTR']
                }
                ];
                this.obj_memberAFF = {
                    RM: null,
                    _d: d
                };
                this.obj_Reject = {
                    "reason": null,
                    "reason2": ""
                },

                    this.bool_isDisqualifyAff = true;
            },
            RequalifyMemberAFF(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["RQMA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: d.MI,
                            UTS: d.UTS,
                            AS: 2,
                            AGI: d.AGI,
                            RI: d.RI
                        };

                        this.postDataApi(`/api/m/uas`, dt,
                            function (d, s) {                                
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getmemberAffiliate();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    } else {
                        this.getmemberAffiliate();
                    }
                });
            },
            saveDisqualifyAFF() {
                this.bool_rejectCV = true;

                var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var dt = {
                        I: this.obj_memberAFF._d.MI,
                        AS: 1,
                        UTS: this.obj_memberAFF._d.UTS,
                        DAR: rejectreason,
                        AGI: this.obj_memberAFF._d.AGI,
                        RI: this.obj_memberAFF._d.RI,
                        ICI: 0
                    };

                    //this.postDataApi(`/api/m/bm`, dt,
                    //    function (d, s)
                    //    {
                    //        that.bool_fullLoading = false;

                    //        if (s)
                    //        {
                    //            that.bool_isDisqualifyAff = false;
                    //            that.getData();
                    //        }
                    //    });
                    this.postDataApi(`/api/m/uas`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '30em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt.ICI = 1;
                                            that.postDataApi(`/api/m/uas`, dt,
                                                function (d, s) {
                                                    that.bool_fullLoading = false;
                                                    if (s) {
                                                        that.bool_isDisqualifyAff = false;
                                                        that.getmemberAffiliate();
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.bool_isDisqualifyAff = false;
                                    that.getmemberAffiliate();
                                }
                            }
                        });
                }
            },
            renderDisqualifyReason(rejectReason) {
                const found = constDisqualifyMemberAff.some(el => el.id === rejectReason);

                if (found) {
                    for (var d of constDisqualifyMemberAff) {
                        if (d.id == rejectReason) {
                            rejectReason = d.label;
                        }
                    }
                }

                return rejectReason;
            },
            ctrPageAff(newPage,inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page_Aff = Math.max(1, Math.min(newPage, this.int_TP_Aff));
                }
                else {
                    this.int_Page_Aff = (newPage > this.int_TP_Aff) ? 1 : (newPage < 1) ? this.int_TP_Aff : newPage;
                }
                this.int_IC_Aff = this.int_Page_Aff;
                this.getmemberAffiliate(this.LVL, this.int_Page_Aff);
            },
            ctrPageAR(newPage,inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page_AR = Math.max(1, Math.min(newPage, this.int_TP_AR));
                }
                else {
                    this.int_Page_AR = (newPage > this.int_TP_AR) ? 1 : (newPage < 1) ? this.int_TP_AR : newPage;
                }
                this.int_IC_AR = this.int_Page_AR;
                this.viewARDetail();
            },
            ctrPageGBT(newPage,inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page_GBT = Math.max(1, Math.min(newPage, this.int_TP_GBT));
                }
                else {
                    this.int_Page_GBT = (newPage > this.int_TP_GBT) ? 1 : (newPage < 1) ? this.int_TP_GBT : newPage;
                }
                this.int_IC_GBT = this.int_Page_GBT;
                if (this.gbtData != null) {
                    this.viewFSDetail(this.gbtData);
                }                
            },
            ctrPageDLS(newPage,inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page_GBT = Math.max(1, Math.min(newPage, this.int_TP_GBT));
                }
                else {
                    this.int_Page_GBT = (newPage > this.int_TP_GBT) ? 1 : (newPage < 1) ? this.int_TP_GBT : newPage;
                }
                this.int_IC_GBT = this.int_Page_GBT;

                if (this.gbtData != null) {
                    this.viewDLSDetail(this.gbtData);
                }
            },
            CountItem(value) {
                if (this.int_IC_AR != 1) {
                    return value + ((this.int_IC_AR - 1) * this.int_RC_AR);
                }
                else {
                    return value;
                }
            },
            CountItemAff(value) {
                if (this.int_IC_Aff != 1) {
                    return value + ((this.int_IC_Aff - 1) * this.int_RC_Aff);
                }
                else {
                    return value;
                }
            },
            CountItemGbt(value) {
                if (this.int_IC_GBT != 1) {
                    return value + ((this.int_IC_GBT - 1) * this.int_RC_GBT);
                } else {
                    return value;
                }
            },

            //action funtion
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_member.R = event.target.value;
                }
            },
            editMember(d) {
                this.editMemberInfo = d;
            },
            editMemberGameSetting(d) {
                this.editMemberGame = d;
            },
            closeEditMemberGameSetting() {
                this.bool_isMemberGameSetting = !this.bool_isMemberGameSetting;
            },
            close1() {
                this.getData();
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_memberCV = false;
            },
            blacklistMember(d) {
                this.editMemberBlock = d;
            },
            unBlacklistMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUBLK"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI,
                            CI: d.CI,
                            U: d.U
                        };

                        this.postDataApi(`/api/m/ubm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getData();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            freezeMember(d) {
                this.editMemberFreeze = d;
            },
            unFreezeMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUF"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/m/ufm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getData();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },

            MegaGamingUserStatus(data) {
                var textColor = '#000';
                if (data == 5) {
                    textColor = '#FF0000';
                }
                else {
                    textColor = '#000';
                }
                return {
                    color: textColor
                };
            },
            showMegaGamingTransfer(GPI) {
                this.CurrentGPI = GPI;
                this.bool_isMegaGamingTransfer = !this.bool_isMegaGamingTransfer;
            },
            closeMegaGamingTransfer() {
                this.CurrentGPI = 0;
                this.bool_isMegaGamingTransfer = !this.bool_isMegaGamingTransfer;
            },
            megaGamingTransfer(transferType, amount, GPI) {
                var that = this;
                //do something here
                try {
                    this.megaGamingTransferObj.I = this.obj_member.I;
                    this.megaGamingTransferObj.AGI = this.obj_member.AGI;
                    this.megaGamingTransferObj.CI = this.obj_member.CI;
                    this.megaGamingTransferObj.transferType = transferType;
                    this.megaGamingTransferObj.amount = amount;
                    this.megaGamingTransferObj.GPI = GPI;

                    this.postDataApi(`/api/gps/mega888/MG/transfer`, this.megaGamingTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (!d.Success) {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Transfered Fail : " + d.Message);

                                    //show transfer failed
                                    that.megaGamingDepositAmount = 0;
                                    that.megaGamingWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Transfered Success");

                                    //that.obj_member.MGW = parseFloat(d.Message);

                                    that.megaGamingDepositAmount = 0;
                                    that.megaGamingWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }

            },
            megaGamingBlock(GPI) {
                this.megaGamingTransferObj.I = this.obj_member.I;
                this.megaGamingTransferObj.AGI = this.obj_member.AGI;
                this.megaGamingTransferObj.CI = this.obj_member.CI;
                this.megaGamingTransferObj.GPI = GPI;
                var that = this;
                this.postDataApi(`/api/gps/mega888/MG/block`, this.megaGamingTransferObj,
                    function (d, s) {
                        if (s) {
                            if (!d.Success) {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d.Message);
                            }
                            else {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Player Blocked");
                            }
                        }
                    });
            },
            megaGamingUnblock(GPI) {
                this.megaGamingTransferObj.I = this.obj_member.I;
                this.megaGamingTransferObj.AGI = this.obj_member.AGI;
                this.megaGamingTransferObj.CI = this.obj_member.CI;
                this.megaGamingTransferObj.GPI = GPI;
                var that = this;
                this.postDataApi(`/api/gps/mega888/MG/unblock`, this.megaGamingTransferObj,
                    function (d, s) {
                        if (s) {
                            if (!d.Success) {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d.Message);
                            }
                            else {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Player Unblocked");
                            }
                        }
                    });
            },
         
            showPussy888Transfer() {
                this.bool_isPussy888Transfer = !this.bool_isPussy888Transfer;
            },
            closePussy888Transfer() {
                this.bool_isPussy888Transfer = !this.bool_isPussy888Transfer;
            },
            Pussy888Transfer(transferType, amount) {
                var that = this;
                //do something here
                try {
                    this.Pussy888TransferObj.I = this.obj_member.I;
                    this.Pussy888TransferObj.AGI = this.obj_member.AGI;
                    this.Pussy888TransferObj.CI = this.obj_member.CI;
                    this.Pussy888TransferObj.U = this.obj_member.U;
                    this.Pussy888TransferObj.transferType = transferType;
                    this.Pussy888TransferObj.amount = amount;

                    this.postDataApi(`/api/gps/pussy888/transfer`, this.Pussy888TransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (!d.success) {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Transfered Fail : " + d.Message);
                                    //alert("Transfered Fail : " + d.Message);
                                    //show transfer failed
                                    that.Pussy888DepositAmount = 0;
                                    that.Pussy888WithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Transfered Success");
                                    // alert("Transfered Success");
                                    //that.obj_member.MGW = parseFloat(d.Message);

                                    that.Pussy888DepositAmount = 0;
                                    that.Pussy888WithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }

            },
            Pussy888Disable() {
                this.bool_fullLoading = true;
                this.Pussy888TransferObj.I = this.obj_member.I;
                this.Pussy888TransferObj.AGI = this.obj_member.AGI;
                this.Pussy888TransferObj.CI = this.obj_member.CI;
                this.Pussy888TransferObj.U = this.obj_member.U;
                var that = this;

                this.postDataApi(`/api/gps/pussy888/disable`, this.Pussy888TransferObj,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (!d.Success) {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Player Disable");
                            }
                            else {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Player Disable Failed: " + d.Message);
                            }
                        }
                    });
                //function (d, s) {
                //    if (s) {
                //        if (!d.success) {
                //            alert(d.msg);
                //        }
                //        else {
                //            alert("Player Disbale");
                //        }
                //    }
                //});

            },
            Pussy888Enable() {
                this.bool_fullLoading = true;

                this.Pussy888TransferObj.I = this.obj_member.I;
                this.Pussy888TransferObj.AGI = this.obj_member.AGI;
                this.Pussy888TransferObj.CI = this.obj_member.CI;
                this.Pussy888TransferObj.U = this.obj_member.U;
                var that = this;

                this.postDataApi(`/api/gps/pussy888/disable`, this.Pussy888TransferObj,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (!d.Success) {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Player Enable");
                            }
                            else {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Player Enable Failed: " + d.Message);
                            }
                        }
                    });
                //function (d, s) {
                //    if (s) {
                //        if (!d.success) {
                //            alert(d.msg);
                //        }
                //        else {
                //            alert("Player Enable");
                //        }
                //    }
                //});
            },

            showKiss918Transfer() {
                this.bool_isKiss918Transfer = !this.bool_isKiss918Transfer;
            },            
            closeKiss918Transfer() {
                this.bool_isKiss918Transfer = !this.bool_isKiss918Transfer;
            },            
            Kiss918Transfer(transferType, amount) {
                var that = this;
                //do something here
                try {
                    this.Kiss918TransferObj.I = this.obj_member.I;
                    this.Kiss918TransferObj.AGI = this.obj_member.AGI;
                    this.Kiss918TransferObj.CI = this.obj_member.CI;
                    this.Kiss918TransferObj.U = this.obj_member.U;
                    this.Kiss918TransferObj.transferType = transferType;
                    this.Kiss918TransferObj.amount = amount;

                    this.postDataApi(`/api/gps/kiss918/transfer`, this.Kiss918TransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (!d.success) {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Transfered Fail : " + d.Message);
                                    //alert("Transfered Fail : " + d.Message);
                                    //show transfer failed
                                    that.Kiss918DepositAmount = 0;
                                    that.Kiss918WithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Transfered Success");
                                    //alert("Transfered Success");
                                    //that.obj_member.MGW = parseFloat(d.Message);

                                    that.Kiss918DepositAmount = 0;
                                    that.Kiss918WithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }

            },
            Kiss918Disable() {
                this.bool_fullLoading = true;
                this.Kiss918TransferObj.I = this.obj_member.I;
                this.Kiss918TransferObj.AGI = this.obj_member.AGI;
                this.Kiss918TransferObj.CI = this.obj_member.CI;
                this.Kiss918TransferObj.U = this.obj_member.U;
                var that = this;

                this.postDataApi(`/api/gps/kiss918/disable`, this.Kiss918TransferObj,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (!d.Success) {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Player Disable");
                            }
                            else {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Player Disable Failed: " + d.Message);
                            }
                        }
                    });
                //function (d, s) {
                //    if (s) {
                //        if (!d.success) {
                //            alert(d.msg);
                //        }
                //        else {
                //            alert("Player Disbale");
                //        }
                //    }
                //});
            },
            Kiss918Enable() {
                this.bool_fullLoading = true;
                this.Kiss918TransferObj.I = this.obj_member.I;
                this.Kiss918TransferObj.AGI = this.obj_member.AGI;
                this.Kiss918TransferObj.CI = this.obj_member.CI;
                this.Kiss918TransferObj.U = this.obj_member.U;
                var that = this;

                this.postDataApi(`/api/gps/kiss918/disable`, this.Kiss918TransferObj,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (!d.Success) {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Player Enable");
                            }
                            else {
                                that.getData();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Player Enable Failed: " + d.Message);
                            }
                        }
                    });
                //function (d, s) {
                //    if (s) {
                //        if (!d.success) {
                //            alert(d.msg);
                //        }
                //        else {
                //            alert("Player Enable");
                //        }
                //    }
                //});
            },
            Kiss918UserStatus(data) {
                var textColor = '#000';
                if (data == 2) {
                    textColor = '#FF0000';
                }
                else {
                    textColor = '#000';
                }
                return {
                    color: textColor
                };
            },

            IG_GFCDeposit(amount) {
                var that = this;
                try {
                    this.IG_GFCTransferObj.I = this.obj_member.I;
                    this.IG_GFCTransferObj.AGI = this.obj_member.AGI;
                    this.IG_GFCTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/ig_gfc/deposit`, this.IG_GFCTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {                                
                                if (d != "Deposit Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.IG_GFCDepositAmount = 0;
                                    that.IG_GFCWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.IG_GFCDepositAmount = 0;
                                    that.IG_GFCWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }

            },
            IG_GFCWithdraw(amount) {
                var that = this;
                try {
                    this.IG_GFCTransferObj.I = this.obj_member.I;
                    this.IG_GFCTransferObj.AGI = this.obj_member.AGI;
                    this.IG_GFCTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/ig_gfc/withdraw`, this.IG_GFCTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d != "Withdraw Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.IG_GFCDepositAmount = 0;
                                    that.IG_GFCWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.IG_GFCDepositAmount = 0;
                                    that.IG_GFCWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }
            },
            showIG_GFCTransfer() {
                this.bool_isIG_GFCTransfer = !this.bool_isIG_GFCTransfer;
            },
            closeIG_GFCTransfer() {
                this.bool_isIG_GFCTransfer = !this.bool_isIG_GFCTransfer;
            },

            IG_LOTTERYDeposit(amount) {
                var that = this;
                try {
                    this.IG_LOTTERYTransferObj.I = this.obj_member.I;
                    this.IG_LOTTERYTransferObj.AGI = this.obj_member.AGI;
                    this.IG_LOTTERYTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/ig_lottery/deposit`, this.IG_LOTTERYTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {                                
                                if (d != "Deposit Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.IG_LOTTERYDepositAmount = 0;
                                    that.IG_LOTTERYWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.IG_LOTTERYDepositAmount = 0;
                                    that.IG_LOTTERYWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }

            },
            IG_LOTTERYWithdraw(amount) {
                var that = this;
                try {
                    this.IG_LOTTERYTransferObj.I = this.obj_member.I;
                    this.IG_LOTTERYTransferObj.AGI = this.obj_member.AGI;
                    this.IG_LOTTERYTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/ig_lottery/withdraw`, this.IG_LOTTERYTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d != "Withdraw Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.IG_LOTTERYDepositAmount = 0;
                                    that.IG_LOTTERYWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.IG_LOTTERYDepositAmount = 0;
                                    that.IG_LOTTERYWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }
            },
            showIG_LOTTERYTransfer() {
                this.bool_isIG_LOTTERYTransfer = !this.bool_isIG_LOTTERYTransfer;
            },
            closeIG_LOTTERYTransfer() {
                this.bool_isIG_LOTTERYTransfer = !this.bool_isIG_LOTTERYTransfer;
            },

            IG_LOTTODeposit(amount) {
                var that = this;
                try {
                    this.IG_LOTTOTransferObj.I = this.obj_member.I;
                    this.IG_LOTTOTransferObj.AGI = this.obj_member.AGI;
                    this.IG_LOTTOTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/ig_lotto/deposit`, this.IG_LOTTOTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d != "Deposit Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.IG_LOTTODepositAmount = 0;
                                    that.IG_LOTTOWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.IG_LOTTODepositAmount = 0;
                                    that.IG_LOTTOWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }

            },
            IG_LOTTOWithdraw(amount) {
                var that = this;
                try {
                    this.IG_LOTTOTransferObj.I = this.obj_member.I;
                    this.IG_LOTTOTransferObj.AGI = this.obj_member.AGI;
                    this.IG_LOTTOTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/ig_lotto/withdraw`, this.IG_LOTTOTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d != "Withdraw Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.IG_LOTTODepositAmount = 0;
                                    that.IG_LOTTOWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.IG_LOTTODepositAmount = 0;
                                    that.IG_LOTTOWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }
            },
            showIG_LOTTOTransfer() {
                this.bool_isIG_LOTTOTransfer = !this.bool_isIG_LOTTOTransfer;
            },
            closeIG_LOTTOTransfer() {
                this.bool_isIG_LOTTOTransfer = !this.bool_isIG_LOTTOTransfer;
            },

            DG3D_FISHINGDeposit(amount) {
                var that = this;
                try {
                    this.DG3D_FISHINGTransferObj.I = this.obj_member.I;
                    this.DG3D_FISHINGTransferObj.AGI = this.obj_member.AGI;
                    this.DG3D_FISHINGTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/dg3d_fishing/deposit`, this.DG3D_FISHINGTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d != "Deposit Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.DG3D_FISHINGDepositAmount = 0;
                                    that.DG3D_FISHINGWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.DG3D_FISHINGDepositAmount = 0;
                                    that.DG3D_FISHINGWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }

            },
            DG3D_FISHINGWithdraw(amount) {
                var that = this;
                try {
                    this.DG3D_FISHINGTransferObj.I = this.obj_member.I;
                    this.DG3D_FISHINGTransferObj.AGI = this.obj_member.AGI;
                    this.DG3D_FISHINGTransferObj.amount = amount;

                    this.postDataApi(`/api/gps/dg3d_fishing/withdraw`, this.DG3D_FISHINGTransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d != "Withdraw Success") {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d);
                                    that.DG3D_FISHINGDepositAmount = 0;
                                    that.DG3D_FISHINGWithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), d);
                                    that.DG3D_FISHINGDepositAmount = 0;
                                    that.DG3D_FISHINGWithdrawAmount = 0;

                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }
            },
            showDG3D_FISHINGTransfer() {
                this.bool_isDG3D_FISHINGTransfer = !this.bool_isDG3D_FISHINGTransfer;
            },
            closeDG3D_FISHINGTransfer() {
                this.bool_isDG3D_FISHINGTransfer = !this.bool_isDG3D_FISHINGTransfer;
            },

            showWICKET9Transfer() {
                this.bool_isWICKET9Transfer = !this.bool_isWICKET9Transfer;
            },
            closeWICKET9Transfer() {
                this.bool_isWICKET9Transfer = !this.bool_isWICKET9Transfer;
            },
            WICKET9Transfer(transferType, amount) {
                var that = this;
                //do something here
                try {
                    this.WICKET9TransferObj.I = this.obj_member.I;
                    this.WICKET9TransferObj.AGI = this.obj_member.AGI;
                    this.WICKET9TransferObj.CI = this.obj_member.CI;
                    this.WICKET9TransferObj.U = this.obj_member.U;
                    this.WICKET9TransferObj.transferType = transferType;
                    this.WICKET9TransferObj.amount = amount;
                    this.postDataApi(`/api/gps/wricket9/transfer`, this.WICKET9TransferObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (!d.success) {
                                    that.bool_fullLoading = false;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), "Transfered Fail : " + d.Message);
                                    //alert("Transfered Fail : " + d.Message);
                                    //show transfer failed
                                    that.WICKET9DepositAmount = 0;
                                    that.WICKET9WithdrawAmount = 0;
                                }
                                else {
                                    that.bool_fullLoading = false;
                                    //update balance
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), "Transfered Success");
                                    // alert("Transfered Success");
                                    //that.obj_member.MGW = parseFloat(d.Message);
                                    that.WICKET9DepositAmount = 0;
                                    that.WICKET9WithdrawAmount = 0;
                                    that.getData();
                                }
                            }
                        });
                }
                catch (e) {
                    console.log(e);
                }
            },

            viewFSDetail(dlsData) {                
                this.gbtData = dlsData;
                this.obj_trans = [];
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page_GBT, this.int_RC_GBT, "CTS", true);                

                if (path) {
                    path += "&";
                }

                path += ("f.D=" + dlsData.BC +
                    "&f.mi=" + dlsData.MI +
                    "&f.GPI=" + dlsData.FSGPI);
                
                this.getDataApi(`/api/dlspromo/lr/trans?${path}`,
                    function (data) {                        
                        that.int_TP_GBT = Math.max(data.D.TotalPages, 1);
                        that.obj_trans = data.D.Items;
                        that.bool_FSD = true;
                        that.bool_fullLoading = false;
                    });
            },
            closeFSD() {
                this.bool_FSD = !this.bool_FSD;
                this.gbtData = null;
                this.int_IC_GBT = 1;
                this.int_Page_GBT = 1;
                this.int_TP_GBT = 1;
            },
            setPreview(newImg, oldImg) {
                this.previewUrl = newImg ? URL.createObjectURL(newImg) : oldImg;
                this.bool_fullPreview = true;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },

            refreshMemberProfile(agi, mi) {
                window.location.href = '/M/ML/CheckingMember?agi=' + agi + '&i=' + mi;
            },
            disableMemberPromotion(member, promoType, isDisabled) {
                var title = "";
                if (isDisabled) {
                    title += this.getLanguage["GL"]["ENB"] + " "
                } else {
                    title += this.getLanguage["GL"]["DISB"] + " "
                }

                if (promoType == 1) {
                    title += this.getLanguage["MEM"]["REWARD"]
                } else if (promoType == 2) {
                    title += this.getLanguage["BTN"]["ARB"]
                } else if (promoType == 3) {
                    title += this.getLanguage["BTN"]["RFR"]
                } else if (promoType == 4) {
                    title += this.getLanguage["BTN"]["PD"]
                } else if (promoType == 5) {
                    title += this.getLanguage["BTN"]["TNMT"]
                }

                this.$fire({
                    title: title,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;                                               
                        var that = this;

                        var dt = {
                            MI: member.I,
                            PT: promoType,                            
                            IDA: !isDisabled
                        }

                        this.postDataApiWithAttach(`/api/m/upts`, dt,
                            function (d, s) {                                                                                                
                                if (s) {                                   
                                    that.bool_fullLoading = false;
                                    that.getData();                                    
                                }
                            });
                    }
                    else {
                        that.bool_fullLoading = false;
                        that.getData();                           
                    }
                });
            },
            disabledPointer() {
                return (!this.checkModuleAccess('ML', 'M', constAccessType.edit)) ? "cursor:not-allowed; filter:none" : "";                              
            },
        },
        validations: {
            obj_ad: {
                TT: { required },
                R: { required },
                TA: { required, decimal, minValueValue: minValue(0) }
            },
        },
        created() {
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.ML';
            this.id = this.$route.query.i;
            this.agi = this.$route.query.agi;
            this.getData();
            this.onOffOptionList = [{ id: '', label: '' }, { id: '0', label: this.getLanguage['GS']['OFF'] }, { id: '1', label: this.getLanguage['GS']['ON'] }];
            this.curAGI = this.getUserInfo.AGI;
            this.HideContactInfo = this.getUserInfo.IHMI_C;
            this.HideBankInfo = this.getUserInfo.IHMI;
            this.EditBankInfo = !this.getUserInfo.IHMI && this.checkModuleAccess('VEB', 'M', constAccessType.edit);
            this.HideCryptoAccountInfo = this.getUserInfo.IHMI;
            this.EditCryptoAccountInfo = !this.getUserInfo.IHMI && this.checkModuleAccess('VEB', 'M', constAccessType.edit);
            this.getmemberAffiliate();
            this.MCMI_V = this.checkModuleAccess('MCMI', 'M', constAccessType.view);
            
        },
        watch: {
            bool_isBAR() {
                if (!this.bool_isBAR && this.bool_barCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            int_Page(newValue) {
                if (newValue > 0 && newValue <= this.int_TP) {
                    this.getTransactionData();
                }
            },
            bool_AFF(newValue) {
                if (!newValue) {
                    this.cleanSuccessErrorMessage();
                }
                if (!this.bool_AFF && this.bool_AFFCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isDisqualifyAff(newValue) {
                if (!newValue) {
                    this.cleanSuccessErrorMessage();
                }
                if (!this.bool_isDisqualifyAff && this.bool_rejectCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getmemberAffiliate();
            },
        }
    }
</script>

<style scoped>
    .text-green-3 {
        color: #00b64d !important;
    }

    .theme-bg-darkblack {
        background-color: #243147 ;
        color: #fff;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .theme-loyalbgvip {
        color: #fff;
        -webkit-box-shadow: none;
        box-shadow: none;
        border: none;
        background-color: rgb(50 55 56 / 1) !important;
    }

    .theme-loyalbgvip.D1C0 {
        background: linear-gradient(313deg, rgba(116, 189, 17, 0) 68.25%, rgba(116, 189, 17, 0.2) 100.63%), linear-gradient(359deg, rgba(116, 189, 17, 0) 13.75%, rgba(116, 189, 17, .2) 134.65%), linear-gradient(319deg, rgba(116, 189, 17, 0) 54.68%, rgba(116, 189, 17, .2) 111.39%)
    }

    .theme-loyalbgvip.D1C1 {
        background: linear-gradient(313deg, rgba(26, 154, 226, 0) 68.25%, rgba(26, 154, 226, 0.2) 100.63%), linear-gradient(359deg, rgba(26, 154, 226, 0) 13.75%, rgba(26, 154, 226, .2) 134.65%), linear-gradient(319deg, rgba(26, 154, 226, 0) 54.68%, rgba(26, 154, 226, .2) 111.39%)
    }

    .theme-loyalbgvip.D1C2 {
        background: linear-gradient(313deg, rgba(240, 50, 232, 0) 68.25%, rgba(240, 50, 232, 0.2) 100.63%), linear-gradient(359deg, rgba(240, 50, 232, 0) 13.75%, rgba(240, 50, 232, .2) 134.65%), linear-gradient(319deg, rgba(240, 50, 232, 0) 54.68%, rgba(240, 50, 232, .2) 111.39%);
    }

    .theme-loyalbgvip.D1C3 {
        background: linear-gradient(313deg, rgba(24, 164, 255, 0) 68.25%, rgba(24, 164, 255, 0.2) 100.63%), linear-gradient(359deg, rgba(24, 164, 255, 0) 13.75%, rgba(24, 164, 255, .2) 134.65%), linear-gradient(319deg, rgba(24, 164, 255, 0) 54.68%, rgba(24, 164, 255, .2) 111.39%)
    }

    .theme-loyalbgvip.D1C4 {
        background: linear-gradient(313deg, rgba(167, 69, 219, 0) 68.25%, rgba(167, 69, 219, 0.2) 100.63%), linear-gradient(359deg, rgba(167, 69, 219, 0) 13.75%, rgba(167, 69, 219, .2) 134.65%), linear-gradient(319deg, rgba(167, 69, 219, 0) 54.68%, rgba(167, 69, 219, .2) 111.39%);
    }

    .theme-loyalbgvip.D1C5 {
        background: linear-gradient(313deg, rgba(224, 27, 65, 0) 68.25%, rgba(224, 27, 65, 0.2) 100.63%), linear-gradient(359deg, rgba(224, 27, 65, 0) 13.75%, rgba(224, 27, 65, .2) 134.65%), linear-gradient(319deg, rgba(224, 27, 65, 0) 54.68%, rgba(224, 27, 65, .2) 111.39%);
    }

    .theme-loyalbgvip.D1C6 {
        background: linear-gradient(313deg, rgba(65, 177, 89, 0) 68.25%, rgba(65, 177, 89, 0.2) 100.63%), linear-gradient(359deg, rgba(65, 177, 89, 0) 13.75%, rgba(65, 177, 89, .2) 134.65%), linear-gradient(319deg, rgba(65, 177, 89, 0) 54.68%, rgba(65, 177, 89, .2) 111.39%);
    }

    .theme-loyalbgvip.D1C7 {
        background: linear-gradient(313deg, rgba(246, 120, 12, 0) 68.25%, rgba(246, 120, 12, 0.2) 100.63%), linear-gradient(359deg, rgba(246, 120, 12, 0) 13.75%, rgba(246, 120, 12, .2) 134.65%), linear-gradient(319deg, rgba(246, 120, 12, 0) 54.68%, rgba(246, 120, 12, .2) 111.39%)
    }

    .theme-loyalbgvip.D1C8 {
        background: linear-gradient(313deg, rgba(229, 61, 28, 0) 68.25%, rgba(229, 61, 28, 0.2) 100.63%), linear-gradient(359deg, rgba(229, 61, 28, 0) 13.75%, rgba(229, 61, 28, .2) 134.65%), linear-gradient(319deg, rgba(229, 61, 28, 0) 54.68%, rgba(229, 61, 28, .2) 111.39%);
    }

    .theme-loyalbgvip.D1C9 {
        background: linear-gradient(313deg, rgba(105, 0, 253, 0) 68.25%, rgba(105, 0, 253, 0.2) 100.63%), linear-gradient(359deg, rgba(105, 0, 253, 0) 13.75%, rgba(105, 0, 253, .2) 134.65%), linear-gradient(319deg, rgba(105, 0, 253, 0) 54.68%, rgba(105, 0, 253, .2) 111.39%);
    }


    .theme-loyalbgvip.D2C0 {
        background: linear-gradient(313deg, rgba(171, 133, 72, 0) 68.25%, rgba(171, 133, 72, 0.2) 100.63%), linear-gradient(359deg, rgba(171, 133, 72, 0) 13.75%, rgba(171, 133, 72, .2) 134.65%), linear-gradient(319deg, rgba(171, 133, 72, 0) 54.68%, rgba(171, 133, 72, .2) 111.39%)
    }

    .theme-loyalbgvip.D2C1, .theme-loyalbgvip.D2C3 {
        background: linear-gradient(313deg, rgba(136, 145, 148, 0) 68.25%, rgba(136, 145, 148, 0.2) 100.63%), linear-gradient(359deg, rgba(136, 145, 148, 0) 13.75%, rgba(136, 145, 148, .2) 134.65%), linear-gradient(319deg, rgba(136, 145, 148, 0) 54.68%, rgba(136, 145, 148, .2) 111.39%);
    }

    .theme-loyalbgvip.D2C2, .theme-loyalbgvip.D2C4 {
        background: linear-gradient(313deg, rgba(169, 99, 51, 0) 68.25%, rgba(169, 99, 51, 0.2) 100.63%), linear-gradient(359deg, rgba(169, 99, 51, 0) 13.75%, rgba(169, 99, 51, .2) 134.65%), linear-gradient(319deg, rgba(169, 99, 51, 0) 54.68%, rgba(169, 99, 51, .2) 111.39%);
    }

    .theme-loyalbgvip.D2C5 {
        background: linear-gradient(313deg, rgba(243, 180, 152, 0) 68.25%, rgba(243, 180, 152, 0.2) 100.63%), linear-gradient(359deg, rgba(243, 180, 152, 0) 13.75%, rgba(243, 180, 152, .2) 134.65%), linear-gradient(319deg, rgba(243, 180, 152, 0) 54.68%, rgba(243, 180, 152, .2) 111.39%);
    }

    .theme-loyalbgvip.D2C6, .theme-loyalbgvip.D2C7 {
        background: linear-gradient(313deg, rgba(163, 182, 209, 0) 68.25%, rgba(163, 182, 209, 0.2) 100.63%), linear-gradient(359deg, rgba(163, 182, 209, 0) 13.75%, rgba(163, 182, 209, .2) 134.65%), linear-gradient(319deg, rgba(163, 182, 209, 0) 54.68%, rgba(163, 182, 209, .2) 111.39%)
    }

    .theme-loyalbgvip.D2C8 {
        background: linear-gradient(313deg, rgba(238, 168, 21, 0) 68.25%, rgba(238, 168, 21, 0.2) 100.63%), linear-gradient(359deg, rgba(238, 168, 21, 0) 13.75%, rgba(238, 168, 21, .2) 134.65%), linear-gradient(319deg, rgba(238, 168, 21, 0) 54.68%, rgba(238, 168, 21, .2) 111.39%);
    }

    .theme-loyalbgvip.D2C9 {
        background: linear-gradient(313deg, rgba(237, 22, 203, 0) 68.25%, rgba(237, 22, 203, 0.2) 100.63%), linear-gradient(359deg, rgba(237, 22, 203, 0) 13.75%, rgba(237, 22, 203, .2) 134.65%), linear-gradient(319deg, rgba(237, 22, 203, 0) 54.68%, rgba(237, 22, 203, .2) 111.39%);
    }

    .theme-loyalbgvip.D3C0 {
        background: linear-gradient(313deg, rgba(171, 133, 72, 0) 68.25%, rgba(171, 133, 72, 0.2) 100.63%), linear-gradient(359deg, rgba(171, 133, 72, 0) 13.75%, rgba(171, 133, 72, .2) 134.65%), linear-gradient(319deg, rgba(171, 133, 72, 0) 54.68%, rgba(171, 133, 72, .2) 111.39%)
    }
    .theme-loyalbgvip.D3C1 {
        background: linear-gradient(313deg, rgba(136, 145, 148, 0) 68.25%, rgba(136, 145, 148, 0.2) 100.63%), linear-gradient(359deg, rgba(136, 145, 148, 0) 13.75%, rgba(136, 145, 148, .2) 134.65%), linear-gradient(319deg, rgba(136, 145, 148, 0) 54.68%, rgba(136, 145, 148, .2) 111.39%)
    }

    .theme-loyalbgvip.D3C2, .theme-loyalbgvip.D3C5 {
        background: linear-gradient(313deg, rgba(192, 98, 106, 0) 68.55%, rgba(192, 98, 106, 0.5) 100.63%), linear-gradient(359deg, rgba(192, 98, 106, 0) 13.75%, rgba(192, 98, 106, .5) 134.65%), linear-gradient(319deg, rgba(192, 98, 106, 0) 54.68%, rgba(192, 98, 106, .5) 111.39%)
    }

    .theme-loyalbgvip.D3C3, .theme-loyalbgvip.D3C6 {
        background: linear-gradient(313deg, rgba(66, 73, 115, 0) 68.55%, rgba(66, 73, 115, 0.5) 100.63%), linear-gradient(359deg, rgba(66, 73, 115, 0) 13.75%, rgba(66, 73, 115, .5) 134.65%), linear-gradient(319deg, rgba(66, 73, 115, 0) 54.68%, rgba(66, 73, 115, .5) 111.39%)
    }

    .theme-loyalbgvip.D3C4, .theme-loyalbgvip.D3C7 {
        background: linear-gradient(313deg, rgba(231, 179, 78, 0) 68.55%, rgba(231, 179, 78, 0.5) 100.63%), linear-gradient(359deg, rgba(231, 179, 78, 0) 13.75%, rgba(231, 179, 78, .5) 134.65%), linear-gradient(319deg, rgba(231, 179, 78, 0) 54.68%, rgba(231, 179, 78, .5) 111.39%)
    }

    .theme-loyalbgvip.D3C8 {
        background: linear-gradient(313deg, rgba(18, 121, 224, 0) 68.55%, rgba(18, 121, 224, 0.5) 100.63%), linear-gradient(359deg, rgba(18, 121, 224, 0) 13.75%, rgba(18, 121, 224, .5) 134.65%), linear-gradient(319deg, rgba(18, 121, 224, 0) 54.68%, rgba(18, 121, 224, .5) 111.39%)
    }

    .theme-loyalbgvip.D3C9 {
        background: linear-gradient(90deg, rgba(254, 184, 26, .3), rgba(237, 22, 203, 0.3));
    }

    .theme-loyalbgvip.D4C0 {
        background: linear-gradient(313deg, rgb(0, 104, 55, 0) 68.25%, rgba(0, 104, 55, 0.2) 100.63%), linear-gradient(359deg, rgba(0, 104, 55, 0) 13.75%, rgba(0, 104, 55, .2) 134.65%), linear-gradient(319deg, rgba(0, 104, 55, 0) 54.68%, rgba(0, 104, 55, .2) 111.39%)
    }

    .theme-loyalbgvip.D4C1 {
        background: linear-gradient(313deg, rgb(84, 16, 26, 0) 68.25%, rgba(84, 16, 26, 0.2) 100.63%), linear-gradient(359deg, rgba(84, 16, 26, 0) 13.75%, rgba(84, 16, 26, .2) 134.65%), linear-gradient(319deg, rgba(84, 16, 26, 0) 54.68%, rgba(84, 16, 26, .2) 111.39%)
    }

    .theme-loyalbgvip.D4C2 {
        background: linear-gradient(313deg, rgb(27, 20, 100, 0) 68.25%, rgba(27, 20, 100, 0.2) 100.63%), linear-gradient(359deg, rgba(27, 20, 100, 0) 13.75%, rgba(27, 20, 100, .2) 134.65%), linear-gradient(319deg, rgba(27, 20, 100, 0) 54.68%, rgba(27, 20, 100, .2) 111.39%);
    }

    .theme-loyalbgvip.D4C3 {
        background: linear-gradient(313deg, rgba(32, 96, 153, 0) 68.25%, rgba(32, 96, 153, 0.2) 100.63%), linear-gradient(359deg, rgba(32, 96, 153, 0) 13.75%, rgba(32, 96, 153, .2) 134.65%), linear-gradient(319deg, rgba(32, 96, 153, 0) 54.68%, rgba(32, 96, 153, .2) 111.39%)
    }

    .theme-loyalbgvip.D4C4 {
        background: linear-gradient(313deg, rgba(241, 90, 36, 0) 68.25%, rgba(241, 90, 36, 0.2) 100.63%), linear-gradient(359deg, rgba(241, 90, 36, 0) 13.75%, rgba(241, 90, 36, .2) 134.65%), linear-gradient(319deg, rgba(241, 90, 36, 0) 54.68%, rgba(241, 90, 36, .2) 111.39%);
    }

    .theme-loyalbgvip.D4C5 {
        background: linear-gradient(313deg, rgba(83, 71, 65, 0) 68.25%, rgba(83, 71, 65, 0.2) 100.63%), linear-gradient(359deg, rgba(83, 71, 65, 0) 13.75%, rgba(83, 71, 65, .2) 134.65%), linear-gradient(319deg, rgba(83, 71, 65, 0) 54.68%, rgba(83, 71, 65, .2) 111.39%);
    }

    .theme-loyalbgvip.D4C6 {
        background: linear-gradient(313deg, rgba(102, 45, 145, 0) 68.25%, rgba(102, 45, 145, 0.2) 100.63%), linear-gradient(359deg, rgba(102, 45, 145, 0) 13.75%, rgba(102, 45, 145, .2) 134.65%), linear-gradient(319deg, rgba(102, 45, 145, 0) 54.68%, rgba(102, 45, 145, .2) 111.39%);
    }

    .theme-loyalbgvip.D4C7 {
        background: linear-gradient(313deg, rgba(83, 71, 65, 0) 68.25%, rgba(83, 71, 65, 0.2) 100.63%), linear-gradient(359deg, rgba(83, 71, 65, 0) 13.75%, rgba(83, 71, 65, .2) 134.65%), linear-gradient(319deg, rgba(83, 71, 65, 0) 54.68%, rgba(83, 71, 65, .2) 111.39%)
    }

    .theme-loyalbgvip.D4C8 {
        background: linear-gradient(313deg, rgba(175, 11, 31, 0) 68.25%, rgba(175, 11, 31, 0.2) 100.63%), linear-gradient(359deg, rgba(175, 11, 31, 0) 13.75%, rgba(175, 11, 31, .2) 134.65%), linear-gradient(319deg, rgba(175, 11, 31, 0) 54.68%, rgba(175, 11, 31, .2) 111.39%);
    }

    .theme-loyalbgvip.D4C9 {
        background: linear-gradient(313deg, rgba(155, 0, 208, 0) 68.25%, rgba(155, 0, 208, 0.2) 100.63%), linear-gradient(359deg, rgba(155, 0, 208, 0) 13.75%, rgba(155, 0, 208, .2) 134.65%), linear-gradient(319deg, rgba(155, 0, 208, 0) 54.68%, rgba(155, 0, 208, .2) 111.39%);
    }

    .theme-loyalbgvip.D5C0 {
        background: linear-gradient(313deg,rgb(65, 71, 106, 0) 68.25%, rgba(65, 71, 106, 0.2) 100.63%), linear-gradient(359deg, rgba(65, 71, 106, 0) 13.75%, rgba(65, 71, 106, .2) 134.65%), linear-gradient(319deg, rgba(65, 71, 106, 0) 54.68%, rgba(65, 71, 106, .2) 111.39%)
    }

    .theme-loyalbgvip.D5C1 {
        background: linear-gradient(313deg, rgb(57, 47, 23, 0) 68.25%, rgba(57, 47, 23, 0.2) 100.63%), linear-gradient(359deg, rgba(57, 47, 23, 0) 13.75%, rgba(57, 47, 23, .2) 134.65%), linear-gradient(319deg, rgba(57, 47, 23, 0) 54.68%, rgba(57, 47, 23, .2) 111.39%)
    }

    .theme-loyalbgvip.D5C2 {
        background: linear-gradient(313deg, rgb(134, 142, 133, 0) 68.25%, rgba(134, 142, 133, 0.2) 100.63%), linear-gradient(359deg, rgba(134, 142, 133, 0) 13.75%, rgba(134, 142, 133, .2) 134.65%), linear-gradient(319deg, rgba(134, 142, 133, 0) 54.68%, rgba(134, 142, 133, .2) 111.39%);
    }

    .theme-loyalbgvip.D5C3 {
        background: linear-gradient(313deg, rgba(155, 107, 45, 0) 68.25%, rgba(155, 107, 45, 0.2) 100.63%), linear-gradient(359deg, rgba(155, 107, 45, 0) 13.75%, rgba(155, 107, 45, .2) 134.65%), linear-gradient(319deg, rgba(155, 107, 45, 0) 54.68%, rgba(155, 107, 45, .2) 111.39%)
    }

    .theme-loyalbgvip.D5C4 {
        background: linear-gradient(313deg, rgba(113, 78, 54, 0) 68.25%, rgba(113, 78, 54, 0.2) 100.63%), linear-gradient(359deg, rgba(113, 78, 54, 0) 13.75%, rgba(113, 78, 54, .2) 134.65%), linear-gradient(319deg, rgba(113, 78, 54, 0) 54.68%, rgba(113, 78, 54, .2) 111.39%);
    }

    .theme-loyalbgvip.D5C5 {
        background: linear-gradient(313deg, rgba(27, 20, 100, 0) 68.25%, rgba(27, 20, 100, 0.2) 100.63%), linear-gradient(359deg, rgba(27, 20, 100, 0) 13.75%, rgba(27, 20, 100, .2) 134.65%), linear-gradient(319deg, rgba(27, 20, 100, 0) 54.68%, rgba(27, 20, 100, .2) 111.39%);
    }

    .theme-loyalbgvip.D5C6 {
        background: linear-gradient(313deg, rgba(31, 80, 51, 0) 68.25%, rgba(31, 80, 51, 0.2) 100.63%), linear-gradient(359deg, rgba(31, 80, 51, 0) 13.75%, rgba(31, 80, 51, .2) 134.65%), linear-gradient(319deg, rgba(31, 80, 51, 0) 54.68%, rgba(31, 80, 51, .2) 111.39%);
    }

    .theme-loyalbgvip.D5C7 {
        background: linear-gradient(313deg, rgba(44, 59, 108, 0) 68.25%, rgba(44, 59, 108, 0.2) 100.63%), linear-gradient(359deg, rgba(44, 59, 108, 0) 13.75%, rgba(44, 59, 108, .2) 134.65%), linear-gradient(319deg, rgba(44, 59, 108, 0) 54.68%, rgba(44, 59, 108, .2) 111.39%)
    }

    .theme-loyalbgvip.D5C8 {
        background: linear-gradient(313deg, rgba(86, 19, 95, 0) 68.25%, rgba(86, 19, 95, 0.2) 100.63%), linear-gradient(359deg, rgba(86, 19, 95, 0) 13.75%, rgba(86, 19, 95, .2) 134.65%), linear-gradient(319deg, rgba(86, 19, 95, 0) 54.68%, rgba(86, 19, 95, .2) 111.39%);
    }

    .theme-loyalbgvip.D5C9 {
        background: linear-gradient(313deg,rgba(98, 20, 28, 0) 68.25%, rgba(98, 20, 28, 0.2) 100.63%), linear-gradient(359deg, rgba(98, 20, 28, 0) 13.75%, rgba(98, 20, 28, .2) 134.65%), linear-gradient(319deg, rgba(98, 20, 28, 0) 54.68%, rgba(98, 20, 28, .2) 111.39%);
    }

    .theme-loyalbgvip.D6C0, .theme-loyalbgvip.D6C1, .theme-loyalbgvip.D6C2, .theme-loyalbgvip.D6C3, .theme-loyalbgvip.D6C4, .theme-loyalbgvip.D6C5, .theme-loyalbgvip.D6C6, .theme-loyalbgvip.D6C7, .theme-loyalbgvip.D6C8, .theme-loyalbgvip.D6C9 {
        background: linear-gradient(313deg,rgba(103, 103, 103, 0) 68.55%, rgba(103, 103, 103, 0.5) 100.63%), linear-gradient(359deg, rgba(103, 103, 103, 0) 13.75%, rgba(103, 103, 103, .5) 134.65%), linear-gradient(319deg, rgba(103, 103, 103, 0) 54.68%, rgba(103, 103, 103, .5) 111.39%)
    }
    
    .turnOnRefresh { background-color: #2eb85c;}
    .turnOffRefresh { background-color: #2eb85c;}
    .turnOnSetting { background-color: #838181;}
    .turnOffSetting { background-color: #838181;}
    .turnOnFreeze { background-color: #1bcff3;}
    .turnOffFreeze { background-color: #54efed;}
    .turnOnBlock { background-color: #e53636;}
    .turnOffBlock { background-color: #e55353;}
    .turnOnPromo { background-color: #7800b6;}
    .turnOffPromo { background-color: #6f6bd6;}


    .custom-table-wrapper::-webkit-scrollbar, div > .custom-table-wrapper::-webkit-scrollbar, div > div > .custom-table-wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .custom-table-wrapper::-webkit-scrollbar-track, div > .custom-table-wrapper::-webkit-scrollbar-track, div > div > .custom-table-wrapper::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    .custom-table-wrapper::-webkit-scrollbar-thumb, div > .custom-table-wrapper::-webkit-scrollbar-thumb, div > div > .custom-table-wrapper::-webkit-scrollbar-thumb {
        background: #bbbbbb;
        border-radius: 10px;
    }

    .custom-table-wrapper::-webkit-scrollbar-thumb:hover, div > .custom-table-wrapper::-webkit-scrollbar-thumb:hover, div > div > .custom-table-wrapper::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    .member-list-action-btn {
        position: relative;
        border-radius: 8px;
        width: 75px;
        min-width: 40px;
        min-height: 40px;
        margin: 0 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex !important;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #fff;
        background-color: #fcfcfc;
        cursor: pointer;
    }

    .member-list-action-btn span {
        font-size: 9px;
    }
    .memberlist-action-btn {
        border: solid 1px #c9c9c9;
        border-radius: 5px;
        color: #fff;
        position: relative;
        font-weight: bold;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 9px;
        padding: 5px;
        cursor: pointer;
        margin-right: 5px;
        width: 100px;
    }

    .action-icon {
        width: 18px;
        height: 18px;
        line-height: 18px;
        border-radius: 50%;
        font-size: 18px;
        text-align: center;
        /*background: #fff;*/
        margin-right: 5px;
        position: relative;
    }

    @media screen and (max-width:480px) {
        .table-header.gh-mobile {
            display: block;
        }

        .searchBtn {
            margin-top: 10px;
        }

        .searchCol {
            margin-top: 5px;
        }
    }

    .searchBtn {
        height: 30px !important;
    }
    .tableCtnLeft {
        text-align: left;
        padding-left: 8px; 
        white-space: nowrap;
    }
    .tableCtnNo {
        width: 60px;
        text-align: left;
        padding-left: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/Page/CheckingMember.vue